{
  "settings": {
    "calendar": {
      "calendar_settings": "Kalenderinstellingen",
      "settings": "Instellingen",
      "select_calendar_type": "Selecteer kalendertype",
      "add_new_calendar_group": "Nieuwe kalendergroep toevoegen",
      "add_new_equipment": "Nieuwe apparatuur toevoegen",
      "new_calendar": "Nieuwe kalender",
      "calendar_group_description": "Gebruik Calendar Group om meerdere kalenders effectief Sort en Group .",
      "group": "Groep",
      "manage_your_calendars_and_groups": "Manage je Calendars and Group",
      "groups": "Group",
      "create_group": "Groep aanmaken",
      "create_calendar": "Kalender maken",
      "calendar_name": "Kalendernaam",
      "group_duration": "Groepsduur",
      "calendar_type": "Type",
      "action": "Actie",
      "round_robin": "Roulatiesysteem",
      "event": "Event",
      "group_name": "Groepsnaam",
      "room_name": "Naam van ruimte",
      "group_description": "Groepsbeschrijving",
      "calendar_url": "Kalender- URL",
      "calendars": "Kalenders",
      "date_updated": "Datum bijgewerkt",
      "status": "Status",
      "action_dropdown": "Actie keuzelijst",
      "calendar_list": "Services gekoppeld aan",
      "edit": "Bewerken",
      "duplicate": "Dupliceren",
      "copy_embed_code": "Insluitcode kopiëren",
      "copy_permanent_link": "Permanente link kopiëren",
      "copy_new_slug_link": "Boekingslink kopiëren",
      "copy_scheduling_link": "Kopieer de boekingslink (verouderd, niet meer ondersteund)",
      "deactivate_calendar": "Kalender uitschakelen",
      "move_to_group": "Verplaats naar groep",
      "delete_calendar": "Kalender verwijderen",
      "delete_group": "Verwijderen",
      "delete_this_group": "Deze Group verwijderen",
      "activate_calendar": "Activeer de kalender",
      "duration": "Duur",
      "all": "every",
      "draft": "Concept",
      "inactive": "Inactief",
      "active": "Dynamic",
      "actions": "activities",
      "rearrange_calendars": "Kalenders opnieuw inplannen",
      "deactivate_all_calendars_in_group": "Suspend every Calendars in Group",
      "activate_all_calendars_in_group": "trigger every kalenders in Group",
      "no_groups_found": "Je Search heeft geen enkele Group opgeleverd.",
      "no_groups_in_location": "Group Sort je kalenders Like Folder. Add Kalenders aan een Group en Share a Individual Scheduling Link, in het kader van Booker Select From meerdere kalenders.",
      "no_calendars_found": "Aan de slag Via kalender Via Created new kalender.",
      "no_calendars_found_search": "Je Search heeft geen kalenders opgeleverd.",
      "delete_calendar_message": "U staat op het punt deze kalender te verwijderen. Wanneer u op 'verwijderen' drukt, worden ook alle bijbehorende afspraken verwijderd.",
      "delete_calendar_message_title": "Deze kalender verwijderen?",
      "duplicate_calendar_message": "U staat op het punt deze kalender te dupliceren. Dit zal een nieuwe kalender aanmaken met dezelfde instellingen als de geselecteerde kalender.",
      "duplicate_calendar_message_title": "Wilt u deze kalender dupliceren?",
      "no_calendars_found_title": "Geen kalenders gevonden",
      "no_groups_in_location_title": "Geen groepen gevonden",
      "delete_group_confirmation_title": "Wilt u deze groep verwijderen?",
      "delete_group_confirmation": "Weet je zeker dat je de Selected Group wilt verwijderen?",
      "delete_group_confirmation_checkbox_title": "Members Calendars en Appointment verwijderen",
      "delete_group_confirmation_checkbox_description": "Door deze optie te selecteren worden ook de agenda's in deze Group verwijderd, samen met every Appointment in die agenda's.",
      "group_status_message_title": "{status} groep en alle geassocieerde kalenders?",
      "calendar_status_message_title": "{status} deze kalender?",
      "calendar_status_message": "U staat op het punt om {status} kalender te wijzigen.",
      "group_status_active_message": "Weet u zeker dat u deze groep wilt inschakelen? Alle kalenders binnen de groep zullen ook worden geactiveerd en beschikbaar zijn voor boekingen.",
      "group_status_inactive_message": "Weet u zeker dat u deze groep wilt uitschakelen? Alle kalenders binnen de groep worden ook gedeactiveerd en zijn beschikbaar voor boekingen.",
      "coming_soon": "Binnenkort beschikbaar",
      "select": "Selecteren",
      "15mins": "15 minuten",
      "cancel": "Annuleren",
      "save": "Archive",
      "create": "Maken",
      "select_calendar_group": "Selecteer kalendergroep",
      "move_calendar_confirmation": "De oude link zal niet meer werken zodra u doorgaat met deze wijziging. Bevestig door het selectievakje aan te vinken.",
      "previously_called_unassigned": " (Eerder genoemd als niet-toegewezen)",
      "scheduling_type": "Selecteer het type kalender",
      "scheduling_type_description": "Select een Calendar Type om uw kalender Configure en Customize hoe Appointment worden Scheduled.",
      "service_menu_name": "Servicemenu naam",
      "template": "Sjabloon",
      "select_template": "Sjabloon selecteren",
      "group_url": "URLGroup",
      "template_description": "U hebt nu de keuze om de Classic- of Neo-sjablonen te selecteren voor de groepsweergave.",
      "rooms": "Room",
      "rooms_name": "Naam",
      "rooms_description": "Beschrijving",
      "rooms_modal_description": "Voeg ruimte toe of bewerk deze.",
      "rooms_capacity": "Totale capaciteit",
      "no_rooms_in_location_title": "Geen kamers gevonden",
      "no_rooms_in_location": "Room found in deze Location",
      "no_equipments_in_location": "Er is geen apparatuur gevonden op deze locatie.",
      "equipments": "Uitrusting",
      "equipment_name": "Naam",
      "equipment_name_search": "Apparaatnaam",
      "equipment_description": "Beschrijving",
      "equipment_modal_description": "Apparatuur toevoegen of bewerken.",
      "add_equipment": "Apparatuur toevoegen/bewerken",
      "add_room": "Kamer toevoegen/bewerken",
      "equipment_quantity": "Totaal aantal",
      "equipment_outOfService": "Hoeveelheid buiten gebruik",
      "no_equipments_in_location_title": "Geen apparatuur gevonden",
      "delete_this_equipment": "Deze Equipment verwijderen",
      "delete_this_rooms": "Verwijder deze kamer",
      "delete_equipment_confirmation": "Weet je zeker dat je deze apparatuur wilt verwijderen?Dit wordt ook verwijderd uit alle gekoppelde agenda's.",
      "delete_rooms_confirmation": "Weet je zeker dat je deze kamer wilt verwijderen?Dit wordt ook verwijderd uit alle gekoppelde agenda's.",
      "add_new_calendar_equipments": "Add new Equipment",
      "no_equipments_found": "Uw zoekopdracht leverde geen resultaten op.",
      "no_rooms_found": "Uw zoekopdracht leverde geen gevonden kamers op.",
      "add_new_calendar_rooms": "new Add",
      "rooms_disable": "Schakel kamer uit",
      "equipments_disable": "Schakel de apparatuur uit",
      "equipments_activate": "Activeer apparatuur",
      "rooms_activate": "Ruimte activeren",
      "create_equipments": "Maak apparatuur aan",
      "create_rooms": "Maak ruimte",
      "select_calendar_rooms_title": "Calendar Select",
      "select_calendar_rooms_description": "U kunt meerdere kalenders selecteren om aan ruimtes te koppelen.",
      "select_calendar_equipments_title": "Calendar Select",
      "select_calendar_equipments_description": "U kunt één kalender selecteren om te koppelen aan de apparatuur.",
      "disable_equipment_title": "{status} Equipment",
      "disable_room_title": "{status} Room",
      "equipments_status_message": "Weet u zeker dat u deze apparatuur wilt {status}?",
      "rooms_status_message": "Weet je zeker dat je deze ruimte wilt {status}?",
      "calendar_resource_disclaimer": "Dit kan gevolgen hebben voor de beschikbaarheid op de bijbehorende servicekalenders.",
      "equipment_disclaimer": "Let op: Als u de apparatuur later weer inschakelt, wordt deze automatisch opnieuw verbonden met de agenda's waarmee deze is gekoppeld.",
      "room_disclaimer": "Let op: als u de ruimte later weer inschakelt, wordt deze automatisch opnieuw verbonden met de agenda's waarmee deze is gekoppeld.",
      "equipment_tab_name": "Uitrusting",
      "rooms_tab_name": "Room",
      "manage_your_rooms": "Beheer hier de kamers voor uw bedrijf.",
      "manage_your_equipments": "Beheer hier de apparatuur voor uw bedrijf.",
      "select_service_calendar_description_equipments": "U kunt meerdere servicekalenders selecteren om aan apparatuur te koppelen.",
      "select_service_calendar_description_rooms": "U kunt meerdere servicekalenders selecteren om aan ruimtes te koppelen.",
      "service_menus": "Servicemenu",
      "manage_your_calendars_groups_and_service_menus": "Beheer uw agenda's, groepen en servicemenu.",
      "new_service_menu": "Menu voor dienstverlening aanmaken",
      "deactivate_service_menu": "Deactiveer het servicemenu",
      "delete_service_menu": "Verwijder dit servicemenu",
      "delete_service_menu_confirmation": "Weet je zeker dat je dit servicemenu wilt verwijderen?",
      "service_menu_status_message_title": "{status} dit servicemenu?",
      "service_menu_status_message": "U staat op het punt om het servicemenu te {status}.",
      "no_service_menus_in_location_title": "Stel uw eigen servicemenu samen",
      "add_new_service_menu": "Nieuw servicemenu toevoegen",
      "no_service_menus_in_location": "Begin met het aanmaken van een nieuw servicemenu en voeg daar groepen aan toe.",
      "no_service_menu_found": "Er is geen servicemenu gevonden",
      "no_service_menu_found_desc": "Uw zoekopdracht leverde geen resultaten op voor servicemenu's.",
      "apply": "Apply",
      "troubleshoot_calendar": "Problemen met de kalender oplossen",
      "round_robin_booking": "Roulatiesysteem",
      "round_robin_description": "Verdeelt Appointment in Group in een wisselend Sort.",
      "round_robin_example": "Bijvoorbeeld: Sales , Onboarding -sessies.",
      "unassigned_booking": "Evenementenkalender",
      "unassigned_description": "Voor fysieke Schedule occurrences zonder Host Relation.",
      "unassigned_example": "Bijvoorbeeld: conferenties, Public seminars, beurzen.",
      "event_booking_alert_title": "Belangrijk",
      "event_booking_alert_message": "Dit type kalender heeft belangrijke verschillen.",
      "event_booking_learn_more": "Lees meer",
      "event_booking_tooltip_title": "Belangrijke informatie:",
      "event_booking_tooltip_content": "• Evenementenkalenders hebben geen gebruikers, dus vergaderingen kunnen niet aan een gebruiker worden toegewezen.  \n• Omdat er geen gebruiker is toegewezen, worden dynamische vergaderlinktools niet ondersteund (Zoom, Google Meet, Microsoft Teams). Om online vergaderingen te gebruiken, kopieer een statische vergaderlink vanuit een willekeurige tool en plak deze in de vergaderlocatie.  \n• Omdat er geen gebruiker is toegewezen, worden vergaderingen niet gesynchroniseerd met de kalender van een gebruiker via Kalenderinstellingen → Verbindingen. Conflictkalenders die daar worden toegevoegd, worden niet meegenomen.  \n• Vergaderingen worden alleen gesynchroniseerd met de kalender die is geselecteerd onder Externe synchronisatie voor deze kalender.  \n• Evenementen worden alleen opgehaald uit en verzonden naar de geselecteerde externe kalender.  \n• Er kan slechts één Google Agenda worden gekoppeld via externe synchronisatie.",
      "class_booking": "Lesboeking",
      "class_booking_description": "Eén Host voldoet aan meerdere Members.",
      "class_booking_example": "Courses : webinars, Group , online Courses.",
      "collective_booking": "Collectieve boeking",
      "collective_booking_description": "Meerdere hosts komen samen op één Members.",
      "collective_booking_example": "Bijvoorbeeld: Panelinterviews, commissiereviews.",
      "service_booking": "Serviceboeking",
      "service_booking_description": "Naadloze Schedule voor op service gebaseerde bedrijven.",
      "service_booking_example": "Bijv.: Spa Appointment, Services, consulten.",
      "personal_booking": "Persoonlijke boeking",
      "personal_booking_description": "Schedule één-op-één gesprekken met een specifieke Group .",
      "personal_booking_example": "Bijvoorbeeld: Vergaderingen met klanten, Private -consulten.",
      "personal": "Persoonlijk",
      "explore_more_types": "Ontdek meer Categories",
      "no_calendars_added": "Nog geen kalenders – stel er een in!",
      "no_calendars_added_description": "Maak je eerste kalender om makkelijk afspraken te maken.",
      "no_groups_added": "Nog geen groepen – begin met organiseren!",
      "no_calendars_yet": "Nog geen kalenders",
      "no_groups_yet": "Er zijn nog geen groepen",
      "no_calendars_access": "Er zijn nog geen kalenders Created . Zodra een kalender is Created, komt deze here te staan. You If geen Access om een kalender aan Create - neem Contact op met uw Admin .",
      "no_groups_access": "Er zijn nog geen Group Configure . Zodra een Group is Created, wordt deze here weergegeven. You If geen Access to Create a Group—Neem Contact op met uw Admin .",
      "no_groups_added_description": "Gebruik Group om je agenda's gestructureerd Keep . Kalenders Add aan een Group en Share a Individual Group voor Simple boeken.",
      "group_success_message": "Group is Created. You now kalenders Add aan deze Group.",
      "choose_calendars": "Selecteer kalenders",
      "do_it_later": "Ik zal het later doen",
      "add_calendars_to_group": "Kalenders toevoegen aan de groep",
      "select_calendars_to_add": "Select every kalenders die You wilt Add aan Group {name}",
      "add_calendars": "Kalender(s) toevoegen",
      "continue": "Doorgaan",
      "conflicting_calendars": "Tegenstrijdige agenda's",
      "conflicting_calendars_description": "De Trailing kalenders zijn al onderdeel of Other Group. Wilt You ze Move naar uw new Group, <b>{name}</b>?",
      "group_associated_with": "Group Current",
      "move_calendar_consent": "I Enable deze kalenders in naar de new Group.",
      "calendars_moved_successfully": "every the Selected kalenders zijn succesvol verplaatst naar {name}.",
      "new_group": "Nieuwe groep",
      "back": "Terug",
      "share_otl": "Share uw Availability op every Date met een unieke Link that Expires After a booking, voor een Manage Access.",
      "copied_to_clipboard": "Gekopieerd naar klembord",
      "generate_link": "Nieuwe link genereren",
      "generate_link_error": "Kan geen eenmalige link genereren. Probeer het opnieuw",
      "share_schedule_link": " De Scheduling Link wordt bepaald Via de Slug. Modify the Slug, en de Scheduling Link past zich automatisch aan de wijziging aan.",
      "share_permanent_link": "Ideaal voor Funnels, Website Redirects, Of Advertisements, de vaste Link blijft constant, onaangetast. Via Slug Dynamic.",
      "copy": "Kopiëren",
      "share_embed_code": "Location deze Code in uw HTML op de plaats waar You uw Widget {embedType} wilt weergeven.",
      "scheduling_link": "Boekingslink",
      "permanent_link": "Permanente link",
      "one_time_link": "Eenmalige link",
      "embed_code": "Insluitcode",
      "loading": "Aan het laden...",
      "share_group": "Groep delen",
      "edit_group": "Groep bewerken",
      "more_options": "Meer opties",
      "share_calendar": "Kalender delen",
      "edit_calendar": "Kalender bewerken",
      "troubleshoot_calendar_link": "Los problemen met de agenda op",
      "calendar_config_success": "Je hebt je persoonlijke kalender/ Group geconfigureerd",
      "close": " Close",
      "added_calendars": "Toegevoegde kalender(s)",
      "select_calendars": "Kalender(s) selecteren",
      "settings_confirmation": "Bevestig deze om Continue Dynamic.",
      "consent_checkbox_title": "Ik begrijp en accepteer deze wijzigingen.",
      "confirm": "Bevestigen",
      "create_group_access_disabled": "You hebt geen Authorization om een Group Create . Your Admin voor Access .",
      "create_calendar_access_disabled": "Je hebt geen Authorization om een maak kalender.Your Admin voor Access .",
      "preview_booking_widget": "Voorbeeldweergave boekingswidget",
      "share_service_menu": "Servicemenu delen",
      "back_message": "Terug naar de kalenderlijst",
      "service_calendars": "Servicekalenders",
      "owned_by": "Eigenaar Via",
      "owned_by_anyone": "Iedereen",
      "owned_by_me": "Ikzelf",
      "all_groups": "Alle groepen",
      "all_calendars": "Alle kalenders",
      "not_grouped": "Niet gegroepeerd",
      "delete_group_desc": "Weet je zeker dat je deze Group wilt verwijderen? Hierdoor worden ook every Members met deze Group verwijderd.",
      "calendar_listing_title": "Kalenderlijst",
      "calendar_group_name": "Naam kalender/groep",
      "success": "Succes",
      "my_calendar": "mijn-kalender",
      "service_calendar_description": "Naadloze planning voor servicebedrijven."
    },
    "preferences": {
      "preferences": "Settings",
      "my_preferences": "Mijn voorkeur",
      "account_preferences": "Accountvoorkeur",
      "user_preferences": "Gebruikersvoorkeuren",
      "set_preferences": "Settings Collection voor uw Account.",
      "scheduling_options": "Planningsopties",
      "meeting_location": "Conferencing Location",
      "zoom": "Zoom",
      "save_preferences": "Voorkeuren opslaan",
      "in_app_preferences": "In app-voorkeuren",
      "set_start_day": "Settings Day voor het Collection van Like voor de app",
      "view_options": "Opties bekijken",
      "services": "Services",
      "feature_toggle_aria": "Functieschakelaar",
      "week_starts_on": "De week begint op",
      "sunday": "Zondag",
      "widget_preferences": "Widget Settings",
      "set_widget_language": "Collection Settings Like Language for Widget",
      "language_and_region": "Language and State",
      "language": "Taal",
      "english": "Dutch",
      "time_format": "Tijdformaat",
      "time_format_value": "13.30 PM",
      "monday": "Monday",
      "custom_meeting_location": "Aangepaste vergaderlocatie",
      "view_appointments_in_1": "Afspraken bekijken in",
      "timezone_uses_details_1": "We zullen deze Tijdzone gebruiken om Afspraaktijden in de app en in uw afspraakgerelateerde e-mails weer te geven — speciaal voor U. Het heeft geen invloed op uw beschikbaarheid of de manier waarop anderen bij u boeken.",
      "business_timezones_1": "Tijdzone van bedrijf",
      "business_timezones_tooltip_1": "Bericht: Door deze optie te kiezen, zorgt u ervoor dat uw weergavevoorkeur overeenkomt met de geselecteerde bedrijfstijdzone. Als de Tijdzone van het Bedrijf verandert, wordt uw weergavetijdzone automatisch aangepast om overeen te komen.",
      "recommended_timezones": "Aanbevolen tijdzones",
      "all_timezones": "Alle tijdzones"
    },
    "availability": {
      "availability": "Beschikbaarheid",
      "my_availability": "Mijn beschikbaarheid",
      "my_availability_and_booking_rules": "Beschikbaarheidskalender",
      "my_availability_and_booking_rules_description": "Stel in wanneer vergaderingen kunnen worden gepland op basis van de beschikbaarheid van medewerkers.",
      "account_availability": "Beschikbaarheid van het account",
      "timezone": "Tijdzone",
      "working_hours": "Openingstijden",
      "set_recurring_hours": "Recurring Collection hour for Conferencing",
      "select_one": "Selecteer één optie",
      "sunday": "Zondag",
      "monday": "Monday",
      "tuesday": "Dinsdag",
      "wednesday": "Woensdag:",
      "thursday": "Donderdag",
      "friday": "Vrijdag",
      "saturday": "Saturday",
      "widget_preferences": "Widget Settings",
      "set_widget_language": "Collection Settings Like Language for Widget",
      "language_and_region": "Language and State",
      "language": "Taal",
      "english": "Dutch",
      "copy_to_all": "Copy to every",
      "save_availability": "Beschikbaarheid opslaan",
      "add_time": "Tijd toevoegen",
      "to": "Naar",
      "select_time": "Tijd selecteren",
      "add_user": "Gebruiker toevoegen",
      "accessRestricted": {
        "header": "Toegang beperkt",
        "message": "U maakt geen deel uit van dit account. Om toegang te krijgen, voegt u zichzelf toe aan dit account via Agentschapinstellingen > Teams > Teamlid bewerken, en wijst u het account toe onder ‘Rollen en rechten’.",
        "contact_admin": "Deze Page is alleen Public voor beheerders. Neem Contact op met uw Admin voor hulp.",
        "button_text": "Ga naar Agentschapinstellingen."
      },
      "schedule": {
        "edit_schedule": "Kalender bewerken",
        "schedule_name": "Naam agenda",
        "schedule_name_required": "Naam agenda is vereist",
        "timezone": "Tijdzone",
        "timezone_placeholder": "Selecteer één optie",
        "start_time": "Begintijd",
        "end_time": "Eindtijd",
        "add_availability_hour": "Beschikbaarheidsuur toevoegen",
        "remove_availability_hour": "Beschikbaarheidsuur verwijderen",
        "unavailable": "Niet beschikbaar",
        "schedule_created": "Agenda gemaakt",
        "schedule_updated": "Agenda bijgewerkt",
        "calendars_selected": "{count} agenda",
        "calendars_selected_multiple": "{count} kalenders",
        "select_users_placeholder": "Zoeken naar gebruikers",
        "edit_default_schedule": "Deze planning bewerken",
        "customize_event_type_schedule": "Agenda alleen voor deze kalender aanpassen",
        "multi_user_description": "Beschikbaarheid bijwerken voor <b>{count} geselecteerde gebruikers</b> - {calendar}",
        "bulk_edit_warning_banner": "Bulk-bewerken ingeschakeld. Wijzigingen zullen de bestaande agenda's voor alle geselecteerde gebruikers overschrijven.",
        "bulk_edit_slot_applies_to_all": "De geselecteerde tijdsperiode zal van toepassing zijn op alle geselecteerde gebruikers.",
        "bulk_edit_slot_applies_to_selected": "De geselecteerde tijdsperiode is van toepassing op {count} geselecteerde gebruiker(s).",
        "bulk_edit_applies_to_all": "Wijzigingen zijn van toepassing op alle {count} geselecteerde gebruikers.",
        "bulk_edit_weekly_hours": "Wekelijkse uren bulk bewerken",
        "bulk_edit_weekly_hours_title": "Wekelijkse uren bulk bewerken",
        "bulk_edit_weekly_hours_desc": "Dit zal de wekelijkse uren vervangen voor alle hieronder vermelde gebruikers.",
        "edit_now": "Bewerk nu",
        "bulk_edit": "Bulkbewerking",
        "choose_days_weekly_hours": "Kies de dag(en) om wekelijkse uren in te stellen",
        "assign_to": "Toewijzen aan:",
        "configure_weekly_hours": "Wekelijkse uren instellen",
        "selected_users": "Geselecteerde gebruikers:",
        "bulk_edit_select_users": "Selecteer gebruikers om toe te passen",
        "bulk_edit_select_users_placeholder": "Selecteer teamleden...",
        "bulk_edit_select_at_least_one": "Selecteer minstens één gebruiker.",
        "bulk_edit_editing_for": "Bewerken voor:",
        "bulk_edit_applies_to": "Van toepassing op:",
        "bulk_edit_user_count": "{count} gebruiker",
        "bulk_edit_users_count": "{count} gebruikers",
        "show_less": "Minder tonen",
        "more": "meer",
        "confirm_delete": "Verwijderen bevestigen",
        "confirm": "Bevestigen",
        "delete_user_date_confirm": "Weet u zeker dat u de datumspecifieke uren voor <b>{userName}</b> op <b>{date}</b> wilt verwijderen?",
        "delete_date_confirm": "Weet u zeker dat u de datumspecifieke uren voor alle gebruikers op <b>{date}</b> wilt verwijderen?",
        "selected_calendar": "geselecteerde kalender",
        "edit_schedule_alert": "Updates die hier worden aangebracht, zijn van toepassing op",
        "schedule": "Inplannen",
        "no_availability": "Geen beschikbaarheid",
        "date_specific_hours_show_more": "meer",
        "date_specific_hours_show_less": "minder",
        "date_specific_hours_recurring_meetings_enabled": "Datumspecifieke uur kunnen niet worden toegevoegd omdat deze planning is gekoppeld aan een kalender met ingeschakelde Terugkerend vergaderingen. Schakel Terugkerende vergaderingen uit om door te gaan.",
        "recurring_incompatible_with_date_hours": "Terugkerende vergaderingen kunnen niet worden ingeschakeld omdat de agenda van de Gebruiker datumspecifieke uren heeft, wat incompatibel is.",
        "incompatible_schedule_with_recurring": "De agenda {user} bevat datumspecifieke uren, wat niet compatibel is met terugkerende vergaderingen.",
        "incompatible_schedule_with_recurring_calendar": "De agenda bevat datumspecifieke uren, wat onverenigbaar is met terugkerende vergaderingen.",
        "recurring_meetings_enabled_multi_user": "Terugkerende vergaderingen worden niet ondersteund voor kalenders met meerdere teamleden of wanneer een teamlid datumspecifieke uren aan hun schema heeft toegevoegd.",
        "weekdays": "Weekdagen, {timeRange}",
        "weekdays_hours_vary": "Weekdagen, uren variëren",
        "weekend": "Weekend, {timeRange}",
        "weekend_hours_vary": "Weekend, uren variëren",
        "days_hours_vary": "{days}, uren variëren",
        "date_specific_hours_tab_name": "Datumspecifieke uren",
        "date_specific_hours": "{count} datumspecifieke uren",
        "date_specific_hours_1": "1 datumspecifiek uur",
        "weekly_hours": "Wekelijkse uren",
        "custom_schedule": "Aangepaste kalender",
        "select_schedule": "Klik op een agenda",
        "no_schedules_found": "Geen agenda's gevonden",
        "untitled": "Zonder titel",
        "error_updating_schedules": "Fout tijdens het bijwerken van schema's",
        "daily": "Dagelijks",
        "weekly": "Wekelijks",
        "monthly": "Maandelijks",
        "custom": "Aangepast",
        "this_is_required": "Dit is vereist",
        "search": "Zoeken",
        "edit_hours": "Uren bewerken",
        "schedule_name_duplicate": "Er bestaat al een agenda met deze naam",
        "delete_schedule_title": "Agenda '{scheduleName}' verwijderen?",
        "delete_schedule_description": "Deze actie kan niet ongedaan worden gemaakt. Weet u zeker dat u wilt doorgaan?",
        "delete_schedule_negative_text": "Annuleren",
        "delete_schedule_positive_text": "Ja, verwijderen.",
        "active_on": "Actief op",
        "weekly_working_hours": "Wekelijkse werktijden",
        "weekly_working_hours_subtext": "Selecteer de dagen en tijden waarop u werkt",
        "copy_availability_hour": "Beschikbaarheidsuur kopiëren",
        "mins": "Minuten",
        "hours": "Uren",
        "save_weekly_hours": "Bespaar wekelijks uren",
        "save_date_specific_hours": "Datumspecifieke uren opslaan",
        "update_weekly_hours_for_users": "Werk de wekelijkse uren bij voor {count} gebruikers",
        "set_date_specific_hours_for_users": "Stel datumgebonden uren in voor {count} gebruikers",
        "set_date_specific_hours_for_user": "Stel datumgebonden uren in"
      }
    },
    "connections": {
      "connections": "Verbindingen",
      "connect": "verbinden",
      "conferencing": "Bijeenkomst",
      "my_connections": "Mijn connecties",
      "account_connections": "Accountkoppelingen",
      "connection_preferences": "Verbindingsvoorkeuren",
      "manage_calendars_conferencing_channels": "Kanalen Manage Calendars en Conferencing",
      "main_integration_calendar": "Hoofdintegratiekalender",
      "event_integration_calendar": "occurrences On a System Calendar that You bent een onderdeel of , Created ook Created On deze geïntegreerde kalender",
      "2way_sync": "2-Way Sync: Create System occurrences From occurrences geboekt On de geïntegreerde kalender PRIMARY",
      "calendars": "Kalenders",
      "google": "Google",
      "outlook": "Outlook",
      "check_for_conflicts": "Controleren op conflicten",
      "choose_accounts_to_connect": "Select welk Account You wilt koppelen",
      "payments": "Betalingen",
      "stripe": "Stripe",
      "ads": "Advertenties",
      "local_service_ads": "Advertenties voor lokale diensten",
      "fire_workflow": "Workflowtriggersactiveren voor evenementen die via 2-weg sync zijn geboekt.",
      "connect_google_outlook": "Koppel uw Google/Outlook/iCloud Account om de PRIMARY Calendar te Select .",
      "execute_automation": "Automatisering uitvoeren",
      "save": "Archive",
      "lsa": "Advertenties voor lokale diensten",
      "no_write_access": "Je kunt niet schrijven Access tot deze kalender",
      "connection_remove_confirmation": "You bent About om deze Integration te Extract",
      "active": "Dynamic",
      "icloud": {
        "title": "iCloud Integration",
        "description": "Twee-stapsverificatie en een app-specifiek password zijn Required om uw Account te koppelen.",
        "email": "iCloud Email address",
        "password": "iCloud-wachtwoord",
        "connect": "Verbinden",
        "cancel": "Annuleren"
      }
    }
  },
  "appointment_modal": {
    "select_a_contact": "Contactpersoon selecteren",
    "start_time": "Begintijd",
    "unassigned": "Niet toegewezen",
    "end_time": "Eindtijd",
    "search_by_name_email_phone_or_company": "Search Via name, Email, Phone Of Business",
    "add_new": "Nieuw toevoegen",
    "pick_from_available_contacts": "Of Select From Available Friends",
    "book_appointment": "Afspraak boeken",
    "add_blocked_off_time": "Gereserveerde tijd toevoegen",
    "recommended_timezones": "Aanbevolen tijdzones",
    "all_timezones": "Alle tijdzones",
    "calendar": "Kalender",
    "repeat": "Herhalen",
    "date_and_time": "Datum en tijd",
    "close": "Close",
    "team_member": "Teamlid",
    "recurring_booking": "Terugkerende boeking",
    "one_slot_booking": "Boeking van één tijdsperiode",
    "event_type": "Type gebeurtenis",
    "occurrences_booked": "occurrences worden geboekt",
    "repeats": "Herhalingen",
    "booking_details": "Boekingsgegevens",
    "showing_slots_in_this_timezone": "Tijdsperiodes in deze tijdzone Showing :",
    "update_contact_tz": "Werk ook de tijdzone van het contact bij naar",
    "date": "Datum",
    "slot": "slot",
    "calendar_default": "Standaard voor kalender",
    "custom": "Aangepast",
    "meeting_notes": "(eg) Conferencing -notities voor onze aankomende Appointment",
    "out_of_office": "(bijv.) From -kantoor voor de Week!",
    "standard": "Standaard",
    "appointment_title": "Titel afspraak",
    "event_title": "Titel gebeurtenis",
    "appt_with_bob": "(bijv.) Afspraak met Bob",
    "vacation": "(bijv.) Vakantie",
    "show_notes": "Opmerkingen weergeven",
    "hide_notes": "Opmerkingen verbergen",
    "additional_preferences": "Aanvullende voorkeuren",
    "meeting_location": "Vergaderlocatie",
    "appointment_status": "Afspraakstatus",
    "appt_description": "Beschrijving afspraak",
    "recurring_details": "Terugkerende gegevens",
    "event_description": "Beschrijving evenement",
    "in_contact_timezone": "in de tijdzone van contactpersoon",
    "vacation_message": "Ga je On vakantie? Disabled Date nemen? Blokkeer Disabled Date On je agenda om te voorkomen dat Customers From booking Appointment Current Appointment blijft On je agenda).",
    "contact": "Contact",
    "delete": "Verwijderen",
    "cancel": "Annuleren",
    "back": "Terug",
    "pick_available_contacts": "Of Select From Available Friends",
    "no_contacts_found": "Geen Friends found",
    "found": "gevonden",
    "select_one": "Selecteer er een",
    "tz_tooltip": "Dit is alleen van You ; zoals Appointment Appointment enz . in uw Outbound Communication met uw Customers Of Customers. Het zet de bovengenoemde Details om naar hun lokale Date.",
    "meeting_location_tooltip": "De Conferencing Location wordt Collection zoals geconfigureerd in de kalender.",
    "appt_meeting_location_tooltip": "De Operator kan de specifieke Conferencing Collection voor de Appointment.",
    "gmeet_tooltip": "Zorg ervoor dat het betreffende teamlid een Google-agenda als hun primaire agenda heeft ingesteld.",
    "zoom_tooltip": "Zorg ervoor dat het betreffende teamlid Zoom heeft geïntegreerd.",
    "enter_meeting_location": "Voer de vergaderlocatie in",
    "save_appointment": "De afspraak opslaan",
    "save_event": "De gebeurtenis opslaan",
    "search_contacts": "Search Via name, Email, Phone Of Business",
    "recurring_slots": "{recurringSlotsLength}/{count}",
    "custom_timezone": "Aangepaste tijdzone",
    "system_timezone": "Systeemtijdzone",
    "contact_timezone": "Tijdzone contactpersoon",
    "account_timezone": "Account tijdzone",
    "an_error_occurred": "Er is een fout opgetreden"
  },
  "popup": {
    "calendar": "Kalender",
    "appointment_owner": "Eigenaar afspraak",
    "source": "Bron",
    "booked_by": "Geboekt door",
    "view_activity_log": "Activiteitenlogboek bekijken",
    "status": "Status",
    "cancel_appointment": "Afspraak annuleren",
    "cancel_all": "Annuleer alles",
    "google_event": "Google-gebeurtenis",
    "outlook_event": "Outlook-gebeurtenis",
    "blocked_slot": "Geblokkeerde periode",
    "appointment": "Afspraak:",
    "confirmed": "Bevestigd",
    "unconfirmed": "Onbevestigd",
    "cancelled": "Geannuleerd",
    "showed": "Showed",
    "no_show": "Niet verschenen",
    "invalid": "Ongeldig",
    "more": "Meer",
    "less": "Minder",
    "edit": "Bewerken",
    "reschedule_all": "Plan alles opnieuw in",
    "guests": "Gast(en)",
    "guest_count": "Guest(s )"
  },
  "create_calendar": {
    "calendar_name": "Naam kalender",
    "calendar_logo": "Logo",
    "select_team_member": "Group Select",
    "select_single_team_member": "Teamlid selecteren",
    "eg_outbound_reach": "(bijv.) Uitgaande bereik",
    "description": "Beschrijving",
    "amount": "Bedrag",
    "description_placeholder": "Beschrijving schrijven",
    "meeting_duration": "Conferencing Duration",
    "meeting_location": "Vergaderlocatie",
    "seats_per_class": "Seats per Class",
    "group": "Groep",
    "custom_url": "Custom URL",
    "meeting_invite_title": "Conferencing Title",
    "event_color": "Color and Event",
    "availability_type": "Type Availability",
    "new_calendar": "Nieuwe kalender",
    "add_description": "Add Description",
    "remove_description": "Extract Description",
    "booking_availability": "Beschikbaarheid boeking",
    "slug_tooltip": "Pas de URL van de boekingswidget aan.",
    "meeting_location_tooltip": "Vergaderlinks worden weergegeven in agenda-evenementen als de 'Vergaderlocatie' en stellen u in staat om bijvoorbeeld Zoom-links voor het evenement toe te voegen.",
    "advanced_settings": "Geavanceerde instellingen",
    "show_more_schedule": "Meer tonen",
    "show_more_helper_text": "Om uw bedrijfsuren verder aan te passen, gaat u naar de geavanceerde instellingen.",
    "reschedule_preference": "Voorkeur voor opnieuw inplannen",
    "reschedule_preference_subtext": "Als een {contactLabel} een afspraak opnieuw inplant:",
    "reassign_through_round_robin": "Opnieuw toewijzen Via Round Robin",
    "keep_same_assinged_user": "Owner Appointment Keep",
    "new_appointment_preference": "Nieuwe afspraakvoorkeur",
    "new_appointment_preference_text": "Boek altijd met de toegewezen gebruiker van {contactLabel}.",
    "new_appointment_preference_subtext": "Boek nieuwe afspraken met de door {contactLabel} toegewezen gebruiker in plaats van gebruik te maken van round-robin planning.",
    "cancel": "Annuleren",
    "confirm": "Bevestigen",
    "service_calendar_name": "Naam service",
    "service_logo": "Logo",
    "service_select_team_member": "Selecteer een medewerker",
    "service_duration": "Duur service",
    "appointment_invite_title": "Appointment Invite Title",
    "payment_placeholder": "Voer een Description in die wordt weergegeven aan de Operator en hem/haar op de hoogte houdt About de betaling",
    "deposit_amount": "Stortingsbedrag",
    "collect_deposit_amount": "Incomplete betaling accepteren",
    "percentage": "Percentage",
    "total_amount": "Totaalbedrag",
    "enter_meeting_location": "Voer de vergaderlocatie in",
    "accept_payments": "Betalingen accepteren",
    "aria": {
      "should_accept_payment": "Moet betaling accepteren"
    },
    "calendar_name_tooltip": "De kalendernaam moet worden weergegeven op de boekingswidget.",
    "booking_availability_tooltip": "Stel de dagen en uren in waarop boekingen kunnen worden gemaakt. Dit zijn uw standaard wekelijkse openingstijden die aan gebruikers worden getoond bij het selecteren van een tijdsperiode.",
    "select_team_member_tooltip": "Selecteer de teamleden die aan deze vergadering zullen deelnemen.",
    "seats_per_class_tooltip": "Stel het maximale aantal deelnemers in dat deze les mag boeken. Zodra alle zetels bezet zijn, is de tijdsperiode niet langer beschikbaar voor reservering.",
    "meeting_color": "Conferencing Color",
    "meeting_duration_tooltip": "Dit stelt de lengte van uw vergadering in, waarmee wordt bepaald hoe lang deze zal duren."
  },
  "calendar_advanced": {
    "general": {
      "quick_tip": "Snelle tip",
      "timezone_change_tip": "Tijdzones kunnen op elk gewenst moment worden gewijzigd onder voorkeuren voor tijdzones.",
      "save": "Wijzigingen opslaan",
      "close": "Close",
      "meeting_details": "Basisgegevens",
      "availability": "Beschikbaarheid",
      "forms_and_payment": "Formulieren & betaling",
      "notifications_and_additional_options": "Meldingen en aanvullende opties",
      "connections": "Verbindingen",
      "customizations": "Aanpassingen",
      "create": "Maken",
      "edit": "Bewerken",
      "equipments": "Ruimtes en uitrusting",
      "service_details": "Servicegegevens",
      "booking_rules": "Boekingsregels",
      "advanced_settings": "Geavanceerde instellingen",
      "form_and_confirmation": "Formulier en bevestiging",
      "payments": "Betalingen",
      "notifications_and_policies": "Meldingen en beleid",
      "widget_appearance": "Widgetweergave",
      "saving_changes": "Just not minute — Saving de laatste Dynamic...",
      "calendar_id": "Agenda-ID",
      "saveCalendarSuccess": "Kalender succesvol opgeslagen",
      "external_sync": "Externe synchronisatie",
      "booking_channels": "Boekingskanalen",
      "meeting_location": "Vergaderlocatie",
      "staff_location": "Medewerkers en locatie"
    },
    "meeting_details": {
      "meeting_location": "Conferencing Location",
      "meeting_location_label": "Vergaderlocatie",
      "enter_meeting_location": "Enter Conferencing Location",
      "click_to_upload": "click om te Upload",
      "square": "Vierkant",
      "circle": "Cirkel",
      "remove_logo": "Extract Logo",
      "meeting_invite_title_tooltip": "Dit is de titel voor de kalendervergadering die wordt weergegeven in uw afsprakenlijstweergave, kalenderweergave en kalenders van derden.",
      "event_color_tooltip": "Kies een kleur voor dit evenement. Kleuren worden gesynchroniseerd met evenementen in Google Agenda.",
      "enter_a_name": "Voer een naam in.",
      "enter_an_event_title": "Voer een evenementtitel in.",
      "high_priority": "Hoge prioriteit",
      "medium_priority": "Gemiddelde prioriteit",
      "low_priority": "Lage prioriteit",
      "priority": "Prioriteit",
      "custom": "Aangepast",
      "zoom_not_added": "De gebruiker heeft hun Zoom-account nog niet verbonden.",
      "opt_avail": "Optimaliseren voor Availability",
      "opt_equal": "Optimaliseren voor gelijke Delivery",
      "team_members": "Group Select",
      "team_members_location": "Selecteer personeel en wijs vergaderlocatie toe",
      "team_member": "Teamlid selecteren",
      "team_member_location": "Selecteer personeel en wijs vergaderlocatie toe",
      "meeting_location_required": "Vergaderlocatie is vereist.",
      "meeting_details": "Basisgegevens",
      "meeting_details_description": "Basisinformatie die wordt gebruikt om deze kalender te identificeren.",
      "or_drag_and_drop": "Van Drag en neerzetten",
      "service_details": "Servicegegevens",
      "team_member_disabled_recurring_tooltip": "Recurring meetings Enable slechts één Group Members. Om meerdere Group Members Disable Add , Recurring",
      "team_member_disabled_class_booking_tooltip": "Er kan slechts één teamlid worden toegevoegd aan een boekingskalender voor lessen.",
      "advanced_settings": "Geavanceerde instellingen",
      "enable_contact_assigned_to_setting": "Om deze Setting in Enable , moet de Form de eerste zijn in de Widget Sort. Plan de Widget Sort From het tabblad Formulieren en betaling Reschedule .",
      "reschedule_preference_setting_tooltip": "Selecteer aan wie de afspraak moet worden toegewezen wanneer een {contactLabel} de afspraak opnieuw plant vanuit de widget boekingen.",
      "appointment_preference_tooltip": "Selecteer of nieuwe afspraken altijd moeten worden geboekt bij de aan de {contactLabel} toegewezen gebruiker. Als een {contactLabel} een toegewezen gebruiker heeft, krijgt die gebruiker de voorkeur; anders wordt het volgens het Round-robin-principe toegewezen. Tip: Schakel \"Personeelsselectie toestaan\" uit om te voorkomen dat boekers het personeelslid in de widget-boekingen kunnen wijzigen.",
      "add_location": "Locatie toevoegen",
      "multiple_locations_neo": "Bied de boeker meerdere locatieopties om uit te kiezen. Meerdere locaties worden alleen ondersteund door de Neo Widget.",
      "make_owner": "Owner Create",
      "only_one_team_member": "Members is slechts één Group toegestaan When meerdere Address worden toegevoegd.",
      "ask_the_booker_error_message": "De locatie 'Ask the Booker' bestaat al.",
      "enter_location": "Voer locatiewaarde in",
      "enter_display_label": "Voer weergavelabel in",
      "add_display_label": "Voeg weergavelabel toe",
      "multiple_location_support_message": "Bied de boeker meerdere locatieopties om uit te kiezen. Meerdere locaties worden alleen ondersteund door de Neo Widget.",
      "only_one_team_member_personal_calendar": "Slechts één teamlid is toegestaan voor een persoonlijke boeking. ",
      "ms_teams_not_added": "De gebruiker heeft hun Microsoft Teams-account nog niet verbonden.",
      "enable_new_appt_preference": "Nieuwe afspraakvoorkeur inschakelen",
      "enable_new_appt_preference_desc": "Als u '<b>Altijd boeken met de toegewezen gebruiker van de {contactLabel}</b>' inschakelt, wordt het <b>formulier</b> automatisch ingesteld als de eerste stap in de widget-volgorde.",
      "location_exists_toast": "Conferencing Location al toegevoegd",
      "not_supported_with_multiple_team_members": "Niet ondersteund voor meerdere teamleden",
      "not_supported_personal_calendar": "Niet ondersteund in uw persoonlijke agenda",
      "not_supported_class_booking": "Niet ondersteund in de lesboekingskalender",
      "not_supported_collective_booking": "Niet ondersteund in de collectieve agenda",
      "not_supported_service_booking": "Niet ondersteund in de servicekalender",
      "not_supported_round_robin": "Niet ondersteund in het roulatiesysteem",
      "not_supported_event": "Niet ondersteund in de evenementenkalender",
      "calendar_logo_tooltip": "Kies een logo dat getoond moet worden op de boekingswidget.",
      "calendar_name_tooltip": "De kalendernaam moet worden weergegeven op de boekingswidget.",
      "description_tooltip": "Beschrijf waar de kalender over gaat, zodat deze op de widget boekingen wordt weergegeven.",
      "group_tooltip": "U kunt deze kalender toewijzen aan een groep (indien aangemaakt). Gebruikers die de groepslink openen, kunnen bladeren en boeken in alle kalenders van die groep.",
      "custom_url_tooltip": "Pas de URL van de boekingswidget aan.",
      "meeting_color_tooltip": "Kies een kleur voor dit evenement. Kleuren worden gesynchroniseerd met evenementen in Google Agenda.",
      "add_display_label_tooltip": "Verberg de werkelijke locatie en toon een aangepast label totdat de vergadering is geboekt (dit geldt wanneer meerdere locaties zijn toegevoegd).",
      "meeting_location_tooltip": "Selecteer een locatie, of kies Aangepast om een adres of vergaderlink toe te voegen.",
      "team_members_location_tooltip": "Selecteer het personeelslid dat deze vergadering zal leiden en stel hun vergaderlocatie in.",
      "meeting_distribution": "Verspreiding van vergaderingen",
      "meeting_distribution_tooltip": "Kies hoe vergaderingen aan medewerkers worden toegewezen.",
      "opt_avail_tooltip": "Wijs vergaderingen toe aan de medewerker die beschikbaar is op het geselecteerde tijdstip, ongeacht eerdere boekingen. Maximaliseert de benutting van open tijdsperioden en verhoogt het succespercentage van boekingen.",
      "opt_equal_tooltip": "Verdeel vergaderingen gelijkmatig over alle medewerkers door eerdere boekingen te volgen. Geeft prioriteit aan eerlijkheid boven beschikbaarheid.",
      "priority_tooltip": "Stel het voorkeursniveau in voor het toewijzen van vergaderingen wanneer er meerdere medewerkers beschikbaar zijn. Personeel met hoge prioriteit wordt als eerste in aanmerking genomen voor boekingen, gevolgd door personeel met gemiddelde en lage prioriteit.",
      "contact_routing_preference": "Contactrouteringsvoorkeur",
      "contact_routing_preference_tooltip": "Bepaal hoe nieuwe en terugkerende {contactsLabel} aan medewerkers worden toegewezen — ofwel via een rouleersysteem of aan hun oorspronkelijke eigenaar.",
      "team_members_location_owner_tooltip": "De hoofdgebruiker die de vergadering beheert en de definitieve vergaderlocatie bepaalt.",
      "owner": "Eigenaar",
      "upload_from_system": "Uploaden vanuit systeem",
      "choose_from_media_storage": "Uit mediaopslag kiezen",
      "only_one_team_member_allowed": "Er mag slechts één teamlid zijn.",
      "at_least_two_team_members_required": "Er zijn minimaal 2 teamleden vereist.",
      "at_least_one_team_member_required": "Er is minimaal één teamlid vereist.",
      "widget_shape": "Widgetvorm:",
      "widget_bookings_path": "/widget/boekingen/",
      "contact_name_placeholder": "&#123;&#123; contact.name &#125;&#125;",
      "profile_photo_alt": "profielfoto",
      "meeting_location_placeholder": "Vergaderlocatie",
      "team_member_meeting_location": "Personeel en vergaderlocatie",
      "meeting_location_desc": "Wijs medewerkers toe aan deze kalenderen stel in waar vergaderingen plaatsvinden.",
      "event_calendar_meeting_location_desc": "Kies waar de vergadering zal plaatsvinden."
    },
    "meeting_location": {
      "ask_the_booker": "Vraag de boeker (boeker betreedt de locatie)",
      "ask_the_booker_desc": "De boeker wordt gevraagd om bij het boeken een vergaderlocatie naar keuze in te voeren",
      "zoom": "Zoom",
      "google_meet": "Google Meet",
      "microsoft_teams": "Microsoft Teams",
      "phone": "Telefoon",
      "full_address": "Volledig adres",
      "custom": "Aangepast",
      "meeting_location": "Vergaderlocatie"
    },
    "availability": {
      "my_availability": "My Availability",
      "calendar_availability": "Beschikbaarheid van de kalender",
      "calendar_availability_desc": "Stel in wanneer vergaderingen kunnen worden geboekt op deze kalender.",
      "set_availability": "Collection uw Availability voor de kalender here.",
      "standard": "Standaard",
      "custom": "Aangepast",
      "to": "Aan",
      "copy_to_all": "Copy to every",
      "add_time": "Add Date",
      "recurring_meeting": "Recurring Conferencing",
      "recurring_info": "Slechts één gebruiker per kalender voor terugkerende boekingen.",
      "repeat": "Herhalen",
      "times_to_repeat": "times naar Repeat",
      "slots_unavailable": "Als er geen tijdsperiodes beschikbaar zijn?",
      "overlap_status": "Status van overlappende Appointment ",
      "meeting_interval": "Vergaderinterval",
      "meeting_duration": "Conferencing Duration",
      "minimum_scheduling": "Min",
      "date_range": "Date Scopes",
      "maximum_bookings_per_day": "Max. boekingen per Day",
      "maximum_bookings_per_slot": "Max. boekingen per slot",
      "maximum_bookings_per_slot_per_user": "Max. boekingen per slot (per Operator)",
      "seats_per_class": "Seats per Class",
      "pre_buffer_time": "Pre BUFFER Date",
      "post_buffer_time": "BUFFER Date Share",
      "pre_buffer_tooltip": "Pre-Buffer is extra tijd die vóór een afspraak kan worden toegevoegd, zodat u extra tijd heeft om u voor te bereiden.",
      "post_buffer_tooltip": "Post-Buffer is extra tijd die na een afspraak kan worden toegevoegd, zodat er extra tijd is om af te ronden.",
      "buffer_time": "BUFFER Date",
      "daily": "Dagelijks",
      "weekly": "Wekelijks",
      "monthly": "Maandelijks",
      "skip_booking": "Boeking overslaan niet-beschikbare tijdsperiodes",
      "continue_booking": "Doorgaan met boeken",
      "book_next_available": "Next beschikbare slot Book",
      "confirmed": "Bevestigd",
      "unconfirmed": "Onbevestigd",
      "enter_valid_hours": "Voer een geldig Open hour in",
      "enter_valid_avail": "Voer een Custom Availability in",
      "availability_type_tooltip": "Select Default Availability voor Monthly boekingen Weekly. Alleen Custom voor boekingen Select beschikbaar On specifieke data.",
      "meeting_interval_tooltip": "Bepaalt hoe vaak boekingsperioden worden weergegeven.\nVoor een vergadering van 30 minuten: \n• Kies 1 uur om de tijdsperiodes aan het begin van elk uur weer te geven. \n• Kies 30 minuten om elke 30 minuten tijdsperioden weer te geven.",
      "date_range_tooltip": "occurrences kunnen de Next n dagen worden Scheduled .",
      "maximum_bookings_per_day_tooltip": "Maximaal aantal vergaderingen toegestaan per dag op deze kalender.",
      "maximum_bookings_per_slot_tooltip": "Beperk het aantal vergaderingen dat een gebruiker in dezelfde tijdsperiode kan ontvangen. Als de limiet is bereikt, wordt de boeking toegewezen aan de volgende gebruiker in de roulatiewachtrij of wordt de tijdsperiode niet meer beschikbaar.",
      "add_days": "Dagen toevoegen",
      "month_on_day": "Monthly On Day",
      "month_on_last_day": "Monthly On",
      "day": "Dag",
      "week": "Week",
      "month": "Maand",
      "mins": "Minuten",
      "hours": "Uren",
      "days": "Dagen",
      "weeks": "Weken",
      "months": "Maanden",
      "meeting_interval_error": "Het vergaderinterval moet tussen 5 minuten en 12 uur liggen.",
      "meeting_duration_error": "De duur van de vergadering moet tussen 1 minuut en 12 uur liggen.",
      "buffer_time_error": "De buffertijd moet minder dan 12 uur zijn.",
      "appointment_interval": "Seconds Appointment",
      "appointment_duration": "Appointment",
      "maximum_appointments_per_day": "Max Appointment per Day",
      "subTitle": "Kies de datum om specifieke uren in te stellen.",
      "heading_1": "Wekelijkse beschikbare uren",
      "scheduling_availability_heading": "Beschikbaarheid boeken",
      "scheduling_availability_tooltip": "Gebruik een bestaand beschikbaarheidsschema of maak een aangepast schema voor deze kalender.",
      "tooltip_1": "Stel uw wekelijkse beschikbaarheidsschema in. Dit zijn uw standaarduren die wekelijks consistent worden toegepast.",
      "heading_2": "When bent You beschikbaar?",
      "unavailable_label": "Niet beschikbaar",
      "tooltip_2": "Modify je schedule voor specifieke data. Monthly Weekly hour overschrijven Via markering Availability Of onbeschikbaarheid voor Selected datums.",
      "date_specific_level": "Add Date specific hour",
      "specific_hours_button": "Datum specifieke uren",
      "specific_hours_description": "Stel aangepaste beschikbaarheid in voor specifieke datums die afwijken van uw wekelijkse agenda.",
      "overlap_error": "Date mogen niet overlap",
      "apply": "Apply",
      "copy_times_to": "times Copy",
      "no_date_specific_heading": "Geen datumspecifieke tijd toegevoegd",
      "no_date_specific_description": "U kunt een specifieke datum en tijd toevoegen aan of verwijderen uit uw beschikbaarheid.",
      "recurring_disabled_conditions_tooltip": "Recurring meetings zijn Disabled. Om ze te trigger , moet de kalender slechts Members Group hebben en geen datumspecifiek hour Incomplete betaling toevoegen.",
      "date_specific_hours_disabled_conditions_tooltip": "Om een datumspecifiek hour Add , moet u ervoor zorgen dat Recurring vergaderingen zijn Disabled.",
      "recurring_disable_event_calendar_conditions": "Recurring meetings zijn Disabled. Om ze trigger, moet je ervoor zorgen dat er geen datumspecifiek hour van Incomplete is toegevoegd.",
      "service_duration": "Duur service",
      "service_interval": "Service Seconds",
      "service_interval_tooltip": "The Conferencing Seconds Fixed hoe vaak boekingen worden weergegeven On de kalender. Voor Model, voor een 30 minute Event , betekent een Seconds van 1 hour dat er slots every hour verschijnen. Een Seconds van 30 minute betekent dat er every 30 minuten verschijnen.",
      "service_duration_tooltip": "This Fixed the Length of your Appointment, Bepaald hoe lang het last zal zijn.",
      "minimum_scheduling_tooltip": "This Fixed the Min Date Required om Book en Appointment Via de Widget. Voor Model, If Collection to 4 hour kan Appointment niet worden geboekt binnen 4 hour of hun Date; boekingen moeten minimaal 4 hour in tevoren worden gemaakt.",
      "look_busy_title": "Druk lijken",
      "look_busy_helper_text": "Hide a Percentage of je beschikbare Appointment On de Booking Widget om drukker en in gevraagd te worden.",
      "look_busy_percentage_description": "Verberg het aantal beschikbare tijdsperiodes per x%.",
      "maximum_bookings_per_slot_tooltip_personal": "Maximaal aantal vergaderingen toegestaan in een enkele tijdsperiode.",
      "enable_recurring_title": "Terugkerende vergadering inschakelen",
      "enable_recurring_desc": "Als u <b>Terugkerende bijeenkomsten</b> inschakelt, worden de volgende instellingen automatisch uitgeschakeld, omdat ze niet naast elkaar kunnen bestaan:",
      "date_specific_hours": "Alle <b>datumspecifieke uren</b> worden verwijderd.",
      "multiple_team_members": "<b>Meerdere teamleden</b> worden verwijderd — er kan slechts één teamlid in deze kalender blijven staan.",
      "partial_payments": "<b>Betalingen Incomplete</b> worden Disabled en het Full bedrag wordt geïnd.",
      "select_team_member_to_keep": "Select een Group Members to Keep in deze kalender:",
      "select_team_member": "Teamlid selecteren",
      "partial_payments_disabled": "Hoe wilt u dan het volledige bedrag voor terugkerende afspraken innen, aangezien gedeeltelijke betalingen worden uitgeschakeld?",
      "enable_date_specific_hours": "Datumspecifieke uren inschakelen",
      "enable_date_specific_hours_desc": "Als u <b>Datumspecifieke uren</b> inschakelt, wordt de volgende instelling automatisch uitgeschakeld, omdat ze niet naast elkaar kunnen bestaan:",
      "recurring_meetings_disabled": "<b>Terugkerende vergaderingen worden uitgeschakeld</b>, {contactsLabel} kan alleen afzonderlijke afspraken boeken op basis van de beschikbare datums die u hebt ingesteld.",
      "payment_preference": "Betalingsvoorkeur:",
      "team_members_in_this_calendar": "Teamleden in deze kalender",
      "other_team_members": "Andere teamleden (niet toegevoegd aan deze kalender)",
      "select_team_member_tooltip": "Selecteer de teamleden die aan deze vergadering zullen deelnemen.",
      "meeting_duration_tooltip": "Dit stelt de lengte van uw vergadering in, waarmee wordt bepaald hoe lang deze zal duren.",
      "date_specific_hours_tooltip": "Pas uw planning aan voor specifieke datums. Overschrijf uw normale wekelijkse uren door voor bepaalde datums aan te geven of u beschikbaar bent of niet.",
      "recurring_meeting_tooltip": "Sta toe dat vergaderingen meerdere keren gedurende een bepaalde periode worden herhaald.",
      "repeat_frequency_tooltip": "Selecteer de frequentie van deze terugkerende gebeurtenis.",
      "time_to_repeat_tooltip": "Het totale aantal herhalingen instellen",
      "slots_unavailable_tooltip": "Kies wat er moet gebeuren als een of meer tijdsperioden in een terugkerende boeking al bezet zijn.",
      "skip_booking_tooltip": "Alleen de beschikbare tijdsperioden worden geboekt. Alle niet-beschikbare datums in de terugkerende reeks worden overgeslagen.",
      "force_book": "Forceboek",
      "force_booking_tooltip": "Alle tijdsperioden worden geboekt, zelfs als er een conflict is. Wees voorzichtig om dubbele boekingen te voorkomen.",
      "book_next_available_tooltip": "Als een geselecteerde tijdsperiode niet beschikbaar is, wordt de volgende beschikbare tijdsperiode op dezelfde terugkerende kalender geboekt (bijv. volgende maandag als het wekelijks is).",
      "slot_interval_tooltip": "Stel het gat in tussen de starttijden van opeenvolgende beschikbare tijdvakken. Bijvoorbeeld, als uw vergadering 30 minuten duurt en u het interval op 60 minuten instelt, kan een gebruiker om 9:00 uur boeken, vervolgens om 10:00 uur, enzovoort — zelfs als elke vergadering slechts 30 minuten duurt.",
      "minimum_scheduling_notice_tooltip": "Vereis dat gebruikers vergaderingen minstens deze tijd van tevoren boeken.",
      "date_range_preferences_tooltip": "Stel in hoe ver in de toekomst boekingen vanaf vandaag kunnen worden gemaakt.",
      "maximum_bookings_per_slot_preferences_tooltip": "Beperk het aantal vergaderingen dat voor dezelfde tijdsperiode kan worden ingepland.",
      "maximum_bookings_per_slot_per_user_preferences_tooltip": "Beperk het aantal vergaderingen dat voor dezelfde tijdsperiode (per gebruiker) kan worden gepland.",
      "pre_buffer_time_tooltip": "Tijd reserveren voor elke vergadering, zodat er extra tijd is om voor te bereiden.",
      "post_buffer_time_tooltip": "Tijd om na elke vergadering te blokkeren, zodat er extra tijd is om af te ronden.",
      "seats_per_class_tooltip": "Stel het maximale aantal deelnemers in dat voor deze les kan worden geboekt. Zodra alle plaatsen zijn bezet, zal de tijdsperiode niet langer beschikbaar zijn voor reservering.",
      "maximum_bookings_per_slot_per_user_tooltip": "Beperk het aantal vergaderingen dat voor dezelfde tijdsperiode (per gebruiker) kan worden gepland.",
      "repeat_frequency": "Herhalingsfrequentie",
      "slot_interval": "Interval tijdvak",
      "skip_booking_helper_text": "Alleen de beschikbare tijdsperioden zullen worden geboekt. Alle niet-beschikbare datums in de terugkerende reeks worden overgeslagen.",
      "force_book_helper_text": "Alle tijdsperioden worden geboekt, zelfs als er een conflict is. Wees voorzichtig om dubbele boekingen te voorkomen.",
      "book_next_available_helper_text": "If een Selected slot niet beschikbaar is, On de Next schedule slot Book (Monday Recurring Next ) .",
      "bulk_edit": "Bulkbewerking",
      "select_users": "Gebruikers selecteren",
      "select_all": "Alles selecteren",
      "times_to_repeat_tooltip": "Het totale aantal herhalingen instellen",
      "custom_recurrence": "Aangepaste herhaling",
      "repeats_every": "Herhaalt elke",
      "availability_schedule": "Beschikbaarheidsschema",
      "availability_schedule_desc": "Stel in wanneer vergaderingen kunnen worden gepland op basis van de beschikbaarheid van medewerkers.",
      "no_users_added": "Geen personeel toegevoegd!",
      "no_users_added_description": "Voeg medewerkers toe om hun beschikbaarheid te controleren",
      "add_users": "Voeg personeel toe",
      "minimum_scheduling_notice_error": "Voer ≤ 1440 minuten in.",
      "please_select_date": "Selecteer een datum om verder te gaan"
    },
    "forms_payment": {
      "forms": "Formulieren en gasten",
      "forms_sub": "Configureer de voorkeuren voor de eindpagina die verschijnt na een succesvolle boeking.",
      "select_form": "Form Select",
      "enable_same_user_assignment": "Wijs contacten toe aan hun respectievelijke kalenderteamleden telkens wanneer een afspraak wordt geboekt.",
      "sticky_contacts_label": "Vastgezet {contactsLabel}",
      "sticky_contacts": "Velden vooraf invullen",
      "confirmation_page": "Page",
      "default": "Standaard",
      "redirect_url": "Omleidings-URL",
      "thank_you": "You",
      "enter_url": "Voer de URL in",
      "enter_thank_you_message": "Voer een bedankbericht in.",
      "amount_tab_hidden_label": "Tijdelijke aanduiding voor tabblad Bedrag",
      "percentage_tab_hidden_label": "Tijdelijke aanduiding voor tabblad Percentage",
      "pixel_id": "Meta Pixel-Id (Optional)",
      "auto_confirm": "new kalenders automatisch bevestigen",
      "configure_payment": "Options Configure",
      "accept_payments": "Betalingen accepteren",
      "test": "Test",
      "live": "Live",
      "enable_guests": "Gasten toevoegen",
      "add_guest_tooltip": "Met 'Gast toevoegen' kan uw deelnemer meerdere deelnemers aan dezelfde afspraak toevoegen.",
      "add_guest_custom_form_tooltip": "Als u deze optie inschakelt, stuurt het systeem een e-mail naar gasten met een link naar het aangepaste formulier zodra hun afspraak is bevestigd. Om dubbele e-mails te voorkomen, moet u ervoor zorgen dat er niet al een aparte bevestigingsmail is ingesteld voor gasten. (Controleer dit in het tabblad 'Meldingen' > 'Bevestigingsmelding').",
      "add_guest_same_form_check": "Stuur hetzelfde formulier per e-mail naar alle gasten om informatie te verzamelen.",
      "payment_tooltip": "Betaling zou alleen in rekening worden gebracht voor het PRIMARY Guest en niet voor de gasten.",
      "default_form": "Default (Voornaam, last naam, Email, Phone, Notities)",
      "select_form_tooltip": "Als u meer informatie wilt verzamelen dan de standaard Voornaam, Achternaam, E-mail en Telefoon van degenen die op deze kalender boeken, maak dan een aangepast formulier in Sites → Formulieren → Builder en selecteer het formulier via de onderstaande vervolgkeuzelijst.",
      "confirmation_page_tooltip": "Zodra iemand een boeking heeft gemaakt, kunt You On Custom Message Select , Show of doorverwijzen naar een Page of uw keuze ( Default ).",
      "add_guest_collect_email": "Naam en Email",
      "add_guest_count_only": "Alleen Count",
      "custom_email_notification": "Stuur een aangepast formulier naar gasten.",
      "consent_label": "Selectievakje Toestemming",
      "consent_input_placeholder": "Toestemmingstekst toevoegen",
      "same_user_assignment_tooltip": "Om deze Setting in Enable , moet de Form eerst On de Widget zijn. Reschedule de Widget naar Status van de Form om deze Setting als eerste te trigger .",
      "consent_tooltip": "Vraag contactpersonen om toestemming te geven bij het boeken van een vergadering.",
      "stripe_error": "Tot twee cijfers achter de komma (Model: 25.99)",
      "auto_confirm_service": "Auto-bevestigen new Appointment",
      "service_form_message": "Als een contactpersoon meerdere diensten boekt, ziet deze alleen het standaardformulier in het servicemenu.",
      "deposit_amount_error": "Het aanbetalingsbedrag moet lager zijn dan het Total .",
      "deposit_percentage_error": "Het Percentage moet minder dan 100% zijn.",
      "partial_payment_tooltip": "Enable Incomplete betalingen om aanbetaling te innen From Customers tijdens de Workflow Appointment .",
      "partial_payment_enable_error": "Het ingevoerde Total moet groter zijn dan 0 om Incomplete betalingen Enable .",
      "payment_disable_text_integration": "Integreer een Provider voor betalingen onder Betalingen > Integraties om betalingen te accepteren",
      "payment_disable_text_recurring": "De betalingsoptie Accepteren is niet beschikbaar voor Recurring -vergaderingen. Betalingen Disable naar Enable .",
      "date_and_time_selector": "Datum- en tijdkiezer",
      "form_selector": "Formulier",
      "order_step": "Stap",
      "widget_order_label": "Widget Sort",
      "widget_order_tool_tip": "Herschik de volgorde van de 'Datum- en tijdkiezer' en 'Formulier' op de kalenderwidget. Sleep en herschik naar wens.",
      "widget_re_order_tooltip": "De volgorde wijzigen is alleen beschikbaar met de Neo Widget -stijl. Schakel over naar Neo om de volgorde opnieuw in Enable .",
      "widget_re_order_disabled_tooltip": "Om de volgorde van de widgets te wijzigen, schakelt u \"Nieuwe afspraakvoorkeur (altijd boeken met de toegewezen gebruiker van {contactLabel})\" uit in het onderdeel Bijeenkomstinfo > Groepleden > Geavanceerde instellingen.",
      "payment_description_error": "De maximale tekenlimiet van 1000 is bereikt.",
      "widget_multiple_location_disabled_tooltip": "De Classic Widget ondersteunt geen meerdere vergaderlocaties. Verwijder eventuele extra locaties om de Classic Widget te gebruiken.",
      "recurring_payment_label": "Appointment Recurring",
      "enable_payments_for_guests": "Betalingen voor gasten inschakelen",
      "guest_payment_description": "Aangezien You de optie \" Gasten Add \" hebt Enabled , kunt You ook de charge per Guest Select When of .",
      "charge_per_attendee": "Kosten per deelnemer",
      "charge_per_attendee_description": "When het Total number Via tijdens het boeken, wordt het totale of Multiply .",
      "click_confirm_description": "Klik op Opslaan om deze wijzigingen toe te passen.",
      "multiply_amount_guests": "Betaling innen voor every deelnemers",
      "multiply_amount_guests_description": "Wanneer ingeschakeld, wordt het te innen bedrag tijdens de boeking vermenigvuldigd met het totale aantal deelnemers, inclusief gasten.",
      "first_appointment_only": "charge voor de eerste Appointment",
      "all_appointments": "charge for every Appointment",
      "no_payment_provider_connected": "Geen betalingsaanbieder verbonden.",
      "no_default_payment_provider": "Geen Provider verbonden",
      "provider_not_supported": "Provider voor Default betaling wordt niet ondersteund",
      "manage_payment_provider": "Betalingsaanbieders beheren",
      "supported_providers": "Ondersteunde providers",
      "paypal_razorpay_helper_text": "Betalingen worden uitsluitend via Razorpay verwerkt, omdat PayPal niet wordt ondersteund bij aangepaste providers.",
      "rearrange_widget_order": "Herschik de volgorde van widgets.",
      "change_form_order": "Dynamic the Form naar de tweede Step in de Widget Sort and Trailing Setting:",
      "change_form_order_desc": "<b>Voorkeur voor nieuwe afspraak (altijd boeken met de toegewezen gebruiker van {contactLabel})</b> wordt uitgeschakeld. Dit betekent dat afspraken kunnen worden geboekt met elk beschikbaar groepslid, in plaats van beperkt te zijn tot de toegewezen gebruiker van {contactLabel}.",
      "enable_mandatory_guest": "Create het toevoegen van ten minste één Guest Required. Guest Fields is vooraf geopend en moet worden ingevuld voor een boeking.",
      "enable_mandatory_guest_count": "Neem het verplichte aantal gasten op in de boekingswidget.",
      "require_guest_for_booking": "Gasten vereisen voor boeking",
      "sticky_contacts_tooltip": "Vooraf invullen velden voor bekende {contactsLabel}.",
      "auto_confirm_tooltip": "Markeer nieuwe vergaderingen automatisch als bevestigd zonder dat handmatige goedkeuring vereist is. Schakel dit uit als u elke boeking handmatig wilt controleren en bevestigen voordat deze wordt ingepland.",
      "confirm_tooltip": "Zodra iemand een boeking maakt, kunt u ervoor kiezen om een aangepast bericht op dezelfde pagina te tonen (standaard) of om hen door te sturen naar een pagina van uw keuze (omleidings-url).",
      "facebook_pixel_id_tooltip": "",
      "accept_payments_tooltip": "Schakel betaling innen tijdens boekingen in.",
      "total_amount_tooltip": "Stel de totale vergoeding voor de vergadering in.",
      "deposit_amount_tooltip": "Bedrag dat bij het boeken als aanbetaling moet worden geïnd.",
      "multiply_amount_guests_all_guests": "Betaling innen voor every deelnemers, inclusief gasten",
      "multiply_amount_guests_all_guests_tooltip": "Wanneer ingeschakeld, wordt het te innen bedrag tijdens de boeking vermenigvuldigd met het totale aantal deelnemers, inclusief gasten.",
      "payment_description": "Betalingsomschrijving",
      "payment_description_desc": "Wordt aan de boeker weergegeven tijdens het invoeren van de betalingsgegevens.",
      "payment_description_tooltip": "Voeg desgewenst nuttige details over de betaling toe.",
      "test_mode_warning": "Dynamic Test– er wordt geen echte Sales verwerkt.",
      "pixel_id_tooltip": "Stuur boekingswidgetactiviteiten zoals weergaven, klikken en inzendingen naar Meta met uw Pixel-ID.",
      "forms_description": "Stel uw voorkeuren en instellingen in voor het verzamelen van klantgegevens tijdens boekingen.",
      "payment_mode": "Betaalmethodes",
      "payment_mode_tooltip": "Schakel tussen Test Mode en Live modus voor betalingen. in Test Mode worden geen echte billing uitgevoerd — gebruik het om de boekings- en Workflow te simuleren. Schakel over naar de Live modus om daadwerkelijke betalingen te accepteren From Customers.",
      "enable_coupon": "Kortingscodes inschakelen",
      "enable_coupon_tooltip": "Sta klanten toe om kortingscodes toe te passen tijdens het boeken. Maak eerst geldige kortingscodes aan onder Betalingen > Kortingscodes om ervoor te zorgen dat ze werken.",
      "guests": "Gasten"
    },
    "notifications": {
      "third_party_cal": "Instellingen voor kalenders van derden",
      "third_party_cal_desc": "Uw voorkeuren voor kalenders van derden instellen",
      "additional_settings": "Aanvullende instellingen",
      "additional_settings_desc": "Configureer aanvullende instellingen voor uw kalender.",
      "notifications": "Meldingen",
      "notifications_sub": "Configureer hoe u boekingsmeldingen verstuurt via e-mail, sms, WhatsApp en in-app meldingen.",
      "edit": "Bewerken",
      "created_on": "Gemaakt op",
      "updated_on": "Bijgewerkt op",
      "delivered": "Geleverd",
      "not_available": "N.v.t.",
      "select_notification_type": "Selecteer het meldingstype.",
      "notification_person": "Wie moet deze Alert Inherit ?",
      "contact": "{contactLabel}",
      "guest": "Gast",
      "assigned_user": "Toegewezen Operator",
      "emails": "Gmail",
      "alert_email_address": "Email address Alert",
      "ack_email": "E - Email",
      "send_google_invites": "Google Agenda Enable om Upload uitnodiging of update Gmail voor deelnemers.",
      "assign_user_to_contact_desc": "Wanneer ingeschakeld, komt de toegewezen gebruiker van het {contactLabel} overeen met de eigenaar van de afspraak met de meest recente wijziging, of deze nu is geboekt, verplaatst of opnieuw toegewezen.",
      "send_google_outlook_invites": "Sta Google / Outlook / iCloud-agenda toe om uitnodigingen en update-e-mails naar deelnemers te verzenden.",
      "assign_user_to_contact": "Wijs {contactsLabel} toe aan hun respectievelijke kalenderteamleden elke keer wanneer een afspraak wordt geboekt.",
      "skip_assigning_user_to_contact": "Het toewijzen van {contactLabel} overslaan als {contactLabel} al een toegewezen gebruiker heeft.",
      "skip_assigning_user_to_contact_desc": "Wanneer ingeschakeld, blijft de toegewezen gebruiker van een {contactLabel} hetzelfde, zelfs als de eigenaar van de afspraak iemand anders is.",
      "assigned_staff": "Toegewezen medewerkers",
      "additional_emails": "Aanvullende Gmail",
      "assign_user_to_staff": "Wijs altijd de contactpersoon toe aan de eigenaar van de afspraak.",
      "allow_cancellation": " Annulering van vergadering toestaan",
      "allow_reschedule": "Sta toe de vergadering opnieuw in te plannen",
      "allow_cancellation_tooltip": "When Enabled, wordt een Link toegevoegd aan de aanvullende Section en opgenomen in de kalenderuitnodiging. Deze Link wordt Expired zoals geconfigureerd Voor de Conferencing start Date, waardoor wordt voorkomen dat de Booker From de Conferencing kan annuleren.",
      "allow_reschedule_tooltip": " When Enabled, wordt een Link voor een nieuwe afspraak toegevoegd aan de aanvullende Section en in de kalenderuitnodiging opgenomen. Deze Link Expired zoals geconfigureerd Voor de Conferencing start Date, waardoor de Booker From de Conferencing niet kan verplaatsen.",
      "cancellation_link_expiry": "De Link Expired",
      "reschedule_link_expiry": "De Link zal Expired",
      "before_meeting": "Voor de Conferencing",
      "cancellation_and_reschedule_policy": "Annulerings- en opnieuw inplanningsbeleid:",
      "meeting_invite_notes": "Opmerkingen bij de uitnodiging voor de vergadering",
      "meeting_invite_notes_tooltip": "Opmerkingen toevoegen die verschijnen in de kalenderuitnodiging die naar klanten wordt gestuurd. Deze opmerkingen worden gesynchroniseerd met kalenders van derden in de vergaderbeschrijving."
    },
    "connections": {
      "connections_heading": "Externe kalendersync",
      "booking_channels_heading": "Boekingskanalen",
      "booking_channels_description": "Configureer hoe deze kalender boekingen ontvangt van externe platforms.",
      "connections_sub": "Synchroniseer vergaderingen met externe kalenders en beheer hoe evenementen worden beheerd.",
      "link_to_calendar": "Link naar kalender",
      "sync_option": "Sync optie",
      "execute_automation": "Automatisering uitvoeren",
      "fire_workflow": "Activeer workflowtriggers voor evenementen die via tweerichtingssync zijn geboekt.",
      "reserve_with_google": "Reserve with Google [Verouderd]",
      "reserve_with_google_setup": "Bekijk configuratie-instructies",
      "reserve_with_google_configure": "Configureren",
      "change": "Wijzigen",
      "rwg_deprecation_notice": "Google heeft <b>Reserve with Google (Local Services Ads)</b> stopgezet. Nieuwe verbindingen of wijzigingen aan bestaande verbindingen worden niet meer ondersteund. Om boekingen van Google te blijven ontvangen, gebruik <b>Google Organische Boeking</b> in plaats daarvan.",
      "rwg_category": "Categorie",
      "rwg_service_type": "Service",
      "connect_lsa": "Maak verbinding met uw advertentieaccount voor lokale services.",
      "reserve_error": "now Book with Google wordt alleen ondersteund voor 'Home Services', 'Onroerend goed', 'Legal Services' (lokale serviceproviders) Business in de VS.",
      "one_way": "Eenrichtingsverkeer",
      "two_way": "Twee richtingen",
      "smart": "Slim",
      "confirm_remove": "Weet je zeker dat je Google Agenda wilt Extract ?",
      "read_only_access": "You hebt geen Access tot deze kalender. Select een andere kalender.",
      "reserve_with_google_desc": "Deze kalenderservice wordt opgenomen in Book met alleen Google On succesvolle Integration.",
      "check_integration": "Check Mark Status Integration",
      "setup_external": "Externe kalender instellen",
      "reserve_price_decimal_error": "Decimale prijs wordt niet ondersteund.",
      "reserve_price_max_error": "Prijs ondersteund voor minder dan 1000.",
      "link_to_calendar_tooltip": "Selecteer de externe kalender om vergaderingen mee te synchroniseren. Google Agenda's die in Agenda-instellingen → Verbindingen zijn verbonden, zijn beschikbaar om te kiezen.",
      "one_way_sync": "Eenrichtingsverkeer",
      "default_one_way": "Standaard Sync (eenrichtingssynchronisatie)",
      "one_way_sync_desc": "Gebeurtenissen uit de gekoppelde agenda worden gesynchroniseerd als geblokkeerde tijdsperiodes en er worden geen contacten gemaakt voor de gasten.",
      "two_way_sync": "Tweerichtingssynchronisatie",
      "two_way_sync_desc": "Contactpersonen worden gemaakt voor gasten die te vinden zijn in gekoppelde agenda-gebeurtenissen en deze gebeurtenissen worden omgezet in systeemafspraken.",
      "smart_sync": "Slimme sync",
      "smart_sync_desc": "Gebeurtenissen uit de gekoppelde agenda worden gesynchroniseerd als afspraken voor bestaande contactpersonen. Als er geen contactpersoon bestaat, worden ze gesynchroniseerd als geblokkeerde slots zonder dat er een nieuwe contactpersoon wordt aangemaakt.",
      "sync_option_tooltip": "Kies hoe gebeurtenissen van de externe kalender worden verwerkt:\n• Eenrichting: Blokkeert tijd in deze kalender zonder {contactsLabel} aan te maken\n• Tweerichting: Maakt vergaderingen en {contactsLabel} van externe kalendergebeurtenissen\n• Slim: Maakt alleen vergaderingen voor bestaande {contactsLabel} en blokkeert tijd voor anderen.",
      "default_sync": "Standaard",
      "default_sync_desc": "Synchroniseert gebeurtenissen uit uw externe kalender met deze kalender.",
      "advanced_sync": "Geavanceerd",
      "advanced_sync_desc": "Synchroniseert gebeurtenissen uit uw externe kalender naar deze kalender en maakt contacten en afspraken aan in het systeem.",
      "assign_contact_to": "Contactpersoon toewijzen aan",
      "select_calendar": "Agenda selecteren",
      "sync_preferences": "Synchronisatievoorkeuren",
      "sync_preferences_desc": "Hoe wilt u uw gekoppelde agenda-gebeurtenissen synchroniseren?",
      "recommended": "Aanbevolen",
      "execute_automation_desc": "Automatisering uitvoeren wanneer een bijeenkomst wordt gemaakt in deze kalender",
      "save": "Wijzigingen opslaan",
      "cancel": "Annuleren",
      "reserve_with_google_title": "Reserveren met Google",
      "current_connection": "Momenteel actieve verbinding:",
      "category": "Categorie",
      "service": "Servicetype",
      "price": "Geschatte prijs",
      "currency": "Valuta"
    },
    "booking_rules": {
      "booking_rules": "Boekingsregels",
      "booking_rules_description": "Beheer hoe en wanneer vergaderingen kunnen worden geboekt."
    },
    "payments": {
      "payments": "Betalingen",
      "payments_description": " Schakel betalingen, regels en kostenmodellen in en beheer ze."
    },
    "extras": {
      "extras": "Aanpassingen",
      "extras_sub": "Collection Widget style en Other Settings.",
      "calendar_widget_style": "Stijl Widget",
      "neo": "Nieuw",
      "classic": "Klassiek",
      "insert_custom_code": "Aangepaste code invoegen",
      "show_seats_per_slot": "Show per slot",
      "allow_reschedule_meeting": "Enable",
      "allow_cancelling_meeting": "Enable Cancel Conferencing",
      "additional_notes": "Aanvullende opmerkingen",
      "cancellation_and_reschedule": "Annulering en Reschedule:",
      "allow_staff": "Selectie van personeel tijdens boeking Enable",
      "code_block_tooltip": "In het HTML blok kunnen scripts van derden krachtige functionaliteit Offer , maar brengen ook risico's met zich mee op het gebied van privacy, beveiliging, prestaties en Page . Daarom raden wij You aan om de Content of deze Code Voor Saving naar de kalender Review .",
      "calendar_image": "Omslagafbeelding kalender",
      "remove_image": "Extract Image",
      "calendar_image_info": "De geüploade afbeelding zal zichtbaar zijn in de groepsweergave voor de Neo-sjabloon en zal niet verschijnen op de individuele kalenderlink.",
      "get_image_from_unsplash": "Verbeter je afbeeldingen met",
      "unsplash": "Unsplash",
      "service_additional_preferences": "Configureer aanvullende voorkeuren",
      "service_image": "Afbeelding van de serviceomslag",
      "service_image_description": "Selecteer een afbeelding die wordt weergegeven in het servicemenu voor deze service.",
      "allow_reschedule_appointment": "Enable",
      "allow_cancelling_appointment": "Appointment annuleren Enable",
      "custom_code_placeholder": "feedback here op Custom Code",
      "calendar_widget_style_desc": "Kies tussen onze klassieke widget of de strakke Neo-widget.",
      "seats_per_slot": "Zetels per tijdsperiode",
      "show_staff_selection": "Selectie van medewerkers",
      "seats_per_slot_desc": " Schakel Booker in om het number of beschikbare Seats per Time Window te View On de Calendar Widget.",
      "show_staff_selection_desc": "Stel boekers in staat om tijdens het boeken van een afspraak direct een medewerker te kiezen vanuit de kalenderwidget. Werkt alleen met de Neo-widget.",
      "widget_re_order_tooltip": "De klassieke widgetstijl staat geen wijzigingen in de volgorde van widgets toe. Zorg ervoor dat de Datum- en Tijdkiezer als eerste en het Formulier als tweede staan voordat u de Klassieke stijl selecteert.",
      "show_staff_selection_desc_service": "Enable naar Select a staff Members rechtstreeks From the Calendar Widget tijdens Appointment Booker .",
      "switch_to_classic_widget": "Schakel over naar de klassieke widget",
      "switch_to_classic_widget_desc": "Als u overschakelt naar de <b>klassieke widget</b>, worden de volgende instellingen automatisch uitgeschakeld, omdat ze niet samen kunnen bestaan:",
      "form_first_disabled": "<b>De Form wordt verplaatst naar de tweede Step</b> in de Widget Sort.",
      "appointment_preference_disabled": "<b>Voorkeur voor nieuwe afspraak (altijd boeken met de toegewezen gebruiker van {contactLabel})</b> wordt uitgeschakeld. Dit betekent dat afspraken kunnen worden geboekt met elk beschikbaar groepslid, in plaats van beperkt te zijn tot de toegewezen gebruiker van de {contactLabel}.",
      "multiple_location_disabled": "<b>Meerdere Conferencing Address</b> worden Deleted en alleen de <b>eerst toegevoegde Location</b> blijft behouden.",
      "insert_custom_code_tooltip": "Pas de widgetstijl aan met uw eigen CSS-code.",
      "classic_tooltip_disabled": "De klassieke widget wordt niet ondersteund voor leskalenders.",
      "show_staff_selection_disabled_tooltip": "Medewerkersselectie wordt alleen ondersteund voor de neo-widget."
    },
    "roomsAndEquipments": {
      "title": "Selecteer ruimtes en uitrusting",
      "description": "Selecteer uit een lijst met ruimtes en apparatuur die samen met deze kalender wordt geboekt.",
      "rooms": "Ruimtes selecteren",
      "equipments": "Selecteer apparatuur"
    }
  },
  "activity_log": {
    "activity_log": "Activiteitenlogboek",
    "date": "Datum",
    "filter_by": "Filter op",
    "calendar_update": "Kalender bijwerken",
    "start_time_update": "Starttijd bijwerken",
    "end_time_update": "Eindtijd bijwerken",
    "title_update": "Titel bijwerken",
    "notes_update": "Opmerkingen bijwerken",
    "appointment_status_update": "Status van de afspraak bijwerken",
    "meeting_location_update": "Update vergaderlocatie",
    "google_sync_update": "Google-sync bijwerken",
    "outlook_sync_update": "Outlook-sync bijwerken",
    "assigned_user_update": "Update toegewezen gebruiker",
    "appointment_status": "Afspraakstatus",
    "assigned_user": "Toegewezen gebruiker",
    "uploaded_to": "Geüpload naar",
    "cancelled": "Geannuleerd",
    "edited": "bewerkt",
    "other_edits": "Andere bewerkingen",
    "view_details": "Bekijk gegevens",
    "all": "Alle"
  },
  "appointment_list": {
    "group_all": "ALLE",
    "group_primary": "PRIMAIRE",
    "group_user": "GEBRUIKERS",
    "group_team": "GROEPEN",
    "group_calendar": "KALENDERS",
    "all_appointments": "Alle afspraken",
    "my_calendar": "Mijn kalender",
    "status_all": "Alle",
    "status_confirmed": "Bevestigde",
    "status_new": "Nieuw (actie vereist)",
    "status_show": "Aanwezigen",
    "status_no_show": "Niet verschenen",
    "status_cancelled": "Annulaties",
    "status_invalid": "Ongeldig",
    "filter_date_added_desc": "Datum toegevoegd (Aflopend)",
    "filter_start_added_desc": "Startdatum (aflopend)",
    "filter_start_added_asc": "Begindatum oplopend vanaf vandaag",
    "button_new_appointment": "Nieuwe afspraak",
    "name": "Naam",
    "title": "Titel",
    "requested_time": "Aangevraagde tijd",
    "date_added": "Datum toegevoegd",
    "calendar": "Kalender",
    "appointment_owner": "Eigenaar afspraak",
    "notes": "Notities",
    "status": "Status",
    "action_view_detail": "Bekijk gegevens",
    "action_view_consent": "Toestemming bekijken",
    "action_view_notes": "Opmerkingen bekijken",
    "action_edit": "Bewerken",
    "action_delete": "Verwijderen",
    "action_reschedule": "Opnieuw inplannen",
    "page_previous": "Vorige",
    "page_next": "Volgende",
    "appointment_notes": "Afspraaknotities",
    "close": "Sluiten",
    "confirm_delete_header": "Verwijder afspraak",
    "confirm_delete_message": "Weet je zeker dat je deze afspraak wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt!",
    "confirm_delete_button": "Verwijderen",
    "confirm_update_header": "Werk afspraakstatus bij",
    "confirm_update_confirmed_message": "Weet je zeker dat je deze afspraak als geverifieerd wilt markeren?",
    "confirm_update_invalid_message": "Weet je zeker dat je deze afspraak als vervallen wilt markeren?",
    "confirm_update_showed_message": "Weet je zeker dat je deze afspraak als aanwezig wilt markeren?",
    "confirm_update_noshow_message": "Weet je zeker dat je deze afspraak als afwezig wilt markeren?",
    "confirm_update_cancelled_message": "Weet je zeker dat je deze afspraak als geannuleerd wilt markeren?",
    "confirm_update_button": "Bijwerken",
    "empty_state_title": "Geen afspraken gevonden",
    "empty_state_description": "Geen afspraken gevonden.",
    "disable_menu_warning": "U heeft geen toestemming om de afsprakengegevens te bekijken of te bewerken omdat de bijbehorende contactpersoon niet aan u is toegewezen. Neem contact op met uw admin voor hulp.",
    "no_contact_warning": "Je hebt momenteel geen toegang tot contactgegevens. Dit kan komen doordat het contact niet aan je is toegewezen. Neem contact op met je admin voor hulp.",
    "consent_label": "Toestemming",
    "ip_address": "IP",
    "youre_viewing_in": "Wordt momenteel bekeken in",
    "appointment_delete_msg": "<b>Opmerking:</b> De afspraak die hier wordt verwijderd, zal niet uit Calendly worden verwijderd.",
    "rescheduled": "Opnieuw ingepland"
  },
  "add_guest": {
    "guest_label": "Gast(en)",
    "search_placeholder": "From Search",
    "add_new": "Nieuw toevoegen",
    "save": "Archive",
    "close": "Close",
    "name": "Naam",
    "phone": "Telefoon",
    "email": "E-mail",
    "guest_label_count": "Guest(s )",
    "guest_count_error": "Count van Guest moeten tussen 1 en 100 . liggen"
  },
  "languages": {
    "danish": "Danish",
    "dutch": "Dutch",
    "english": "English",
    "finnish": "Finnish",
    "french": "French",
    "french_canada": "French (Canada)",
    "german": "German",
    "hungarian": "Hungarian",
    "italian": "Italian",
    "norwegian": "Norwegian",
    "polish": "Polish",
    "portuguese_brazil": "Portuguese (Brazil)",
    "portuguese_portugal": "Portuguese (Portugal)",
    "spanish": "Spanish",
    "swedish": "Swedish",
    "turkish": "Turkish"
  },
  "service_menu_advanced": {
    "new_service_menu_details_header": "Details van het servicemenu",
    "select_groups_header": "Services selecteren",
    "arrange_groups_header": "Je Services Configure",
    "new_service_menu": "Nieuw servicemenu",
    "service_menu_sub_title": "Create een Custom servicemenu aan voor uw Customers in slechts een paar klikken",
    "quick_tip": "Je kunt Add Group naar het servicemenu",
    "service_menu_name": "Naam servicemenu",
    "service_menu_description": "Beschrijving",
    "service_menu_slug": "Service URL",
    "select_groups_calendars": "Select Group en kalenders",
    "select_groups_calendars_desc": "Voeg diensten toe aan uw servicemenu.",
    "select_all": "Alles selecteren",
    "arrange_groups": "of Sort Configure",
    "arrange_groups_desc": "Bepaal de Pipeline of On het servicemenu",
    "arrange_services_quicktip": "Om Calendars Reschedule binnen Group, gaat u naar Group > Options > Calendars Reschedule .",
    "enable_add_guest_desc": "Customers Enable op extra gasten Add When het maken van een boeking.",
    "enable_multiple_service_desc": "Customers Enable om meerdere Services in a Individual te Book .",
    "enable_staff_selection_desc": "Enable naar Select personeel Members When het maken van een boeking.",
    "enable_add_guest": "Inschakelen gasten toevoegen",
    "enable_multiple_service": "Selectie van meerdere services inschakelen",
    "enable_staff_selection": "Schakel medewerkersselectie in",
    "additional_options": "Aanvullende opties",
    "code_block_tooltip": "In het HTML blok kunnen scripts van derden krachtige functionaliteit Offer , maar brengen ook risico's met zich mee op het gebied van privacy, beveiliging, prestaties en Page . Daarom raden wij You aan de Content of deze Code Voor Saving in het servicemenu Review .",
    "custom_code_placeholder": "feedback here op Custom Code",
    "insert_custom_code": "Aangepaste code invoegen",
    "no_service": "Geen service gevonden",
    "no_service_desc": " Geen Services found. Services Create en ze Add aan Group to Create menu.",
    "learn_more": "Lees meer",
    "no_service_selected": "Selected service",
    "create_service_calendars": "Serviceagenda's Create",
    "alert_description": " Om een servicemenu te maken, moet u servicekalenders maken en deze aan groepen toevoegen.",
    "dont_show_again": "Show dit niet meer",
    "service_name_required": "De naam van het servicemenu is vereist",
    "slug_already_taken": "Deze Slug is al gebruikt",
    "slug_required": "Slug is Required",
    "please_enter_name": "Voer een naam in",
    "service_name_placeholder": "Hoofdmenu",
    "service_slug_placeholder": "hoofdmenu",
    "form_label": "Formulier",
    "consent_label": "Selectievakje Toestemming",
    "consent_input_placeholder": "Toestemmingstekst toevoegen",
    "consent_tooltip": "Schakel deze optie in om goedkeuring van {contactsLabel} te verkrijgen wanneer ze hun telefoonnummer opgeven tijdens het boekingsproces van een afspraak.",
    "back_message": "Terug naar de lijst",
    "saving_changes": "Just not minute — Saving de laatste Dynamic...",
    "payment_provider_warning": "Let op! Service menu's ondersteunen momenteel alleen betalingen via Stripe en Authorize.net. Aangezien uw standaardprovider verschilt, wordt het innen van betalingen voor geselecteerde agenda's waarvoor betalingen zijn ingeschakeld, overgeslagen.",
    "aria": {
      "consent_form_toggle": "Schakelaar toestemmingsformulier",
      "enable_add_guest_toggle": "Schakelaar gast toevoegen inschakelen",
      "enable_multiple_services_toggle": "Schakelaar meerdere services inschakelen",
      "enable_staff_selection_toggle": "Schakelaar selectie van medewerkers inschakelen"
    }
  },
  "widget_configuration": {
    "customise_calendar_widget": "Customize Calendar Widget",
    "works_with_neo_widget": "Werkt alleen met Neo Widget",
    "customise_widget_desc": "Customize Widget Appearance: PRIMARY Color, Background Color and Button Body.",
    "learn_more": "Lees meer",
    "primary_settings": "PRIMARY",
    "primary_settings_desc": "Stel de primaire kleur, achtergrondkleur en andere widgetvoorkeuren in om uw kalenderwidget aan te passen.",
    "primary_color": "PRIMARY",
    "primary_color_desc": "Definieer de kleur voor knoppen, datums, tijdsperioden en acties.",
    "background_color": "Background Color",
    "background_color_desc": "Collection die dient Background achtergrond voor Color date-uur selector als Form.",
    "button_text": "Knoptekst",
    "button_text_desc": "Pas de tekst aan die op de knop wordt weergegeven wanneer een afspraak wordt geboekt.",
    "calendar_title": "Kalendertitel",
    "calendar_title_desc": "De naam van je kalender",
    "calendar_description": "Beschrijving van kalender",
    "calendar_description_desc": "De ingevoerde beschrijving.",
    "calendar_details": "Kalendergegevens",
    "calendar_details_desc": "Bevat informatie zoals duur, datum en tijd, terugkerende details en tijdzone.",
    "reset_to_default": "Reset naar Default",
    "preview_widget": "Voorvertoning widget",
    "calendar_title_tooltip": "instellen of de kalendernaam en de groepsnaam (indien van toepassing) zichtbaar moeten zijn op de boekingswidget.",
    "calendar_description_tooltip": "Stel in of de kalenderbeschrijving zichtbaar moet zijn op de boekingswidget.",
    "calendar_details_tooltip": "Collection If Key afspraken Details zoals Conferencing Duration, Selected Date & Date en herhalingsinfo (If van toepassing) moeten zichtbaar zijn On de Booking Widget.",
    "insert_custom_code_tooltip": "Customize Widget -styling Via je eigen CSS Code.",
    "staff_selection_tooltip": "Enable naar Select a staff Members rechtstreeks From the Calendar Widget tijdens Appointment Booker . Werkt alleen met Neo Widget."
  },
  "eventNotification": {
    "customFields": "Aangepaste velden",
    "customValues": "aangepaste waarden",
    "guest": "Gast",
    "assignedUser": "Toegewezen gebruiker",
    "additionalEmails": "Aanvullende e-mailadressen",
    "list": {
      "booked": {
        "title": "Afspraak geboekt (status: niet bevestigd)",
        "modalTitle": "afspraak geboekt (status: niet bevestigd)",
        "note": "Deze melding wordt verstuurd wanneer een nieuwe afspraak wordt gemaakt met de status Onbevestigd.",
        "subTitle": "Geeft een melding wanneer een afspraak is geboekt met een onbevestigde status."
      },
      "confirmation": {
        "title": "Afspraak geboekt (status: Bevestigd)",
        "modalTitle": "Afspraak geboekt (Status: Bevestigd)",
        "note": "Deze melding wordt verzonden wanneer een afspraak wordt gemaakt met, of bijgewerkt naar de status Bevestigd.",
        "subTitle": "Geeft een melding wanneer een afspraak succesvol is bevestigd."
      },
      "cancellation": {
        "title": "Annulering",
        "modalTitle": "Annulering",
        "note": "Deze melding wordt verzonden wanneer een afspraak wordt geannuleerd, als no-show wordt gemarkeerd of als ongeldig wordt gemarkeerd.",
        "subTitle": "Geeft een waarschuwing wanneer een afspraak wordt geannuleerd"
      },
      "reschedule": {
        "title": "Opnieuw inplannen",
        "modalTitle": "Opnieuw inplannen",
        "note": "Deze Alert is sent When Appointment is opnieuw ingepland. Het wordt alleen geactiveerd If de Appointment de Status in of Confirmed heeft.",
        "subTitle": "Geeft een melding wanneer een afspraak wordt verplaatst."
      },
      "reminder": {
        "title": "Herinnering",
        "modalTitle": "herinnering",
        "note": "Deze Alert is sent als Reminder voor Appointment. Het wordt alleen geactiveerd If de Appointment de Status in of Confirmed heeft.",
        "subTitle": "Stuurt een herinnering voor de afspraak."
      },
      "followup": {
        "title": "Vervolg",
        "modalTitle": "vervolg",
        "note": "Deze melding wordt na de afspraak als vervolgbericht verzonden. Dit wordt alleen geactiveerd als de afspraak de status Onbevestigd, Bevestigd of Weergegeven heeft.",
        "subTitle": "Stuurt een vervolgbericht nadat de afspraak is voltooid."
      }
    },
    "saveToastMsg": "Instellingen opgeslagen!",
    "saveToastMsgDesc": "Uw wijzigingen zijn opgeslagen.",
    "enableSuccess": "Meldingen ingeschakeld!",
    "disableSuccess": "Meldingen uitgeschakeld!",
    "tooltip": "Deze melding is uitgeschakeld. Schakel deze in om wijzigingen aan te brengen.",
    "enabled": "Ingeschakeld",
    "disabled": "Uitgeschakeld",
    "statusLabel": "Statuslabels",
    "email": {
      "channelName": "E-mail",
      "noneTemplate": "Geen",
      "notificationLabel": "Wie moet deze pushmelding ontvangen?",
      "sendButtonLabel": "Test-e-mail verzenden",
      "testEmailLabel": "Test-e-mail",
      "testEmailPlaceholder": "Voer het e-mailadres van de ontvanger in voor testdoeleinden",
      "body": "E-mail tekst",
      "bodyPlaceholder": "Typ hier uw bericht",
      "subject": "Onderwerp",
      "subjectPlaceholder": "Voer het onderwerp van de e-mail in",
      "templateLabel": "E-mailsjabloon",
      "templatePlaceholder": "Selecteer een e-mailsjabloon of begin helemaal opnieuw",
      "fromNamePlaceholder": "Naam invoeren",
      "fromNameLabel": "Van-naam",
      "fromAddressLabel": "Van adres",
      "alertEmailAddress": "Voer e-mail-ID's in (gescheiden door komma's)",
      "addMore": "Meer toevoegen",
      "afterAppointmentEnds": "nadat de afspraak is afgelopen",
      "beforeAppointmentStarts": "voordat de afspraak begint",
      "durationLabel": "Wanneer wilt u de pushmelding activeren?",
      "disableEmailNotification": "E-mailmeldingen uitschakelen",
      "enableEmailNotification": "E-mailmeldingen inschakelen",
      "enableSuccess": "E-mailmelding ingeschakeld!",
      "enableSuccessDesc": "U ontvangt vanaf nu deze melding",
      "disableSuccess": "E-mailmelding uitgeschakeld!",
      "disableSuccessDesc": "U ontvangt deze melding niet meer",
      "reset_to_default": "Reset naar Default",
      "testEmailSuccessTitle": "Testmail verzonden",
      "testEmailSuccessDesc": "De test-e-mail is verzonden naar {email}",
      "testEmailErrorTitle": "Verzenden van test-e-mail mislukt",
      "testEmailErrorDesc": "Er is een fout opgetreden bij het verzenden van de test-e-mail. Probeer het opnieuw.",
      "create_new_email_template": "Maak een nieuw e-mailsjabloon aan"
    },
    "inApp": {
      "channelName": "In de app",
      "title": "Meldingsinstellingen",
      "enableInAppNotification": "Meldingen in de app inschakelen",
      "disableInAppNotification": "Meldingen in de app uitschakelen",
      "selectedUser": {
        "label": "Verzenden naar",
        "helperText": "Deze interne melding wordt verstuurd via het web en de mobiele app",
        "placeholder": "Selecteer gebruiker(s)"
      },
      "enableSuccess": "In-app-meldingen ingeschakeld!",
      "enableSuccessDesc": "U ontvangt vanaf nu deze melding.",
      "disableSuccess": "In-app-meldingen uitgeschakeld!",
      "disableSuccessDesc": "U ontvangt deze melding niet meer."
    },
    "sms": {
      "channelName": "Sms",
      "noneTemplate": "Geen",
      "notificationLabel": "Voor wie is deze melding bedoeld?",
      "sendButtonLabel": "Test-sms verzenden",
      "testSMSLabel": "Test-sms (voer telefoonnummer met landcode in)",
      "testSMSPlaceholder": "+12345678901",
      "body": "Sms-bericht",
      "bodyPlaceholder": "Typ hier uw sms-bericht",
      "durationLabel": "Wanneer wilt u de pushmelding activeren?",
      "disableSMSNotification": "Sms-meldingen uitschakelen",
      "enableSMSNotification": "Sms-meldingen inschakelen",
      "enableSuccess": "Sms-melding ingeschakeld!",
      "enableSuccessDesc": "U ontvangt vanaf nu deze melding.",
      "disableSuccess": "Sms-melding uitgeschakeld!",
      "disableSuccessDesc": "U ontvangt deze melding niet meer.",
      "alertPhoneNumbers": "Voer telefoonnummers in (met landcodes, gescheiden door komma's)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Meer toevoegen",
      "afterAppointmentEnds": "nadat de afspraak is afgelopen",
      "beforeAppointmentStarts": "voordat de afspraak begint",
      "templateLabel": "SMS-sjabloon",
      "templatePlaceholder": "Selecteer sms-sjabloon...",
      "reset_to_default": "Terugzetten naar standaard",
      "testSmsSuccessTitle": "Test-sms verzonden!",
      "testSmsSuccessDesc": "De test-sms is verzonden naar {phone}.",
      "testSmsErrorTitle": "Test-sms verzenden mislukt",
      "testSmsErrorDesc": "Er is een fout opgetreden bij het verzenden van de test-sms. Probeer het opnieuw."
    },
    "whatsapp": {
      "channelName": "WhatsApp",
      "notificationLabel": "Voor wie is deze melding bedoeld?",
      "sendButtonLabel": "Stuur een WhatsApp-testmelding",
      "testWhatsAppLabel": "Test WhatsApp-melding (voer telefoonnummer met landcode in)",
      "testWhatsAppPlaceholder": "+12345678901",
      "durationLabel": "Wanneer wilt u de melding activeren?",
      "alertPhoneNumbers": "Voer telefoonnummers in (met landcodes, gescheiden door komma's)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Meer toevoegen",
      "afterAppointmentEnds": "nadat de afspraak is afgelopen",
      "beforeAppointmentStarts": "voordat de afspraak begint",
      "templateLabel": "WhatsApp-sjabloon",
      "templatePlaceholder": "WhatsApp-sjabloon selecteren",
      "noPreview": "Geen sjabloon geselecteerd",
      "templateRequired": "Sjabloon vereist",
      "testWhatsAppSuccessTitle": "WhatsApp-testmelding verzonden!",
      "testWhatsAppSuccessDesc": "WhatsApp-testmelding is succesvol verzonden naar {phone}.",
      "testWhatsAppErrorTitle": "Het verzenden van de test-WhatsApp-melding is mislukt.",
      "testWhatsAppErrorDesc": "Er is een fout opgetreden bij het verzenden van de test-WhatsAppmelding. Probeer het opnieuw.",
      "setupTitle": "Contacteer uw klanten via hun favoriete communicatie-app.",
      "setupDescription": "Sta uw klanten beter bij met directe ondersteuning, tijdige updates en boeiende interacties.",
      "connectWhatsApp": "WhatsApp koppelen",
      "checkingStatus": "WhatsApp-accountstatus controleren...",
      "checkingTemplateStatus": "WhatsApp-sjabloonstatus controleren...",
      "statusCheckError": "Kan de status van het WhatsApp-account niet controleren.",
      "templateStatusCheckError": "Statuscontrole WhatsApp-sjabloon mislukt.",
      "setupTemplateTitle": "Voltooi de configuratie van uw WhatsApp-sjabloon.",
      "setupTemplateDescription": "U moet WhatsApp-sjablonen configureren voor u meldingen kunt uploaden. Klik hieronder om het installatieproces te voltooien.",
      "loadTemplatesError": "Kan WhatsApp-sjablonen niet laden.",
      "templatesRefreshed": "Sjablonen succesvol vernieuwd",
      "templatesRefreshError": "Vernieuwen sjablonen mislukt.",
      "templatesResolveError": "Fout bij het oplossen van WhatsApp-standaardsjablonen.",
      "locationNotFound": "Locatie-ID niet gevonden.",
      "settingsRedirectError": "Kan niet doorverwijzen naar WhatsApp-instellingen.",
      "updateNotificationError": "Kan WhatsApp-melding niet bijwerken.",
      "notificationsEnabled": "WhatsApp-meldingen zijn ingeschakeld!",
      "notificationsDisabled": "WhatsApp-melding uitgeschakeld!",
      "updateError": "Fout bij het bijwerken van meldingen.",
      "createNewTemplate": "Nieuwe WhatsApp-sjabloon maken",
      "phoneValidation": {
        "countryCodeRequired": "Het telefoonnummer moet beginnen met een landcode (bijvoorbeeld +1, +91, +44).",
        "digitsOnly": "Het telefoonnummer mag alleen cijfers bevatten na de landcode.",
        "tooShort": "Telefoonnummer is te kort.",
        "tooLong": "Telefoonnummer is te lang.",
        "invalid": "Ongeldig telefoonnummer"
      },
      "errors": {
        "templateNotFound": "Sjabloon-ID niet gevonden in geladen opties, wissen.",
        "templateNoLongerValid": "Opgeslagen sjabloon niet langer geldig, wissen.",
        "invalidTemplateSelection": "Er is geprobeerd een ongeldig WhatsApp-sjabloon te selecteren.",
        "fetchingTemplates": "Fout bij het ophalen van WhatsApp-sjablonen.",
        "mountingCreator": "Fout bij het monteren van WhatsApp Template Creator.",
        "fetchingAfterCreation": "Fout bij het ophalen van WhatsApp-sjablonen na het aanmaken.",
        "updateStatus": "Fout bij het bijwerken van WhatsApp-status."
      },
      "receiverLabels": {
        "assignedUser": "Toegewezen gebruiker",
        "phoneNumbers": "Aanvullende telefoonnummers"
      }
    }
  },
  "smsTemplate": {
    "create_new_template": "Nieuw sms-sjabloon maken",
    "create_new_template_desc": "Maak een herbruikbaar sms-sjabloon voor uw meldingen.",
    "template_name": "Naam van sjabloon",
    "template_name_placeholder": "Voer de sjabloonnaam in",
    "message": "Bericht",
    "message_placeholder": "Typ hier uw sms-bericht",
    "create_template": "Sjabloon maken",
    "name_required": "Sjabloonnaam is vereist",
    "text_required": "Berichttekst is vereist",
    "fetch_new_templates": "Sjablonen vernieuwen",
    "characters": "tekens",
    "words": "woorden",
    "segments": "segmenten"
  },
  "whatsappTemplate": {
    "create_new_template": "Nieuwe WhatsApp-sjabloon maken",
    "create_new_template_desc": "Maak een herbruikbare WhatsApp-sjabloon voor uw meldingen.",
    "template_name": "Naam van sjabloon",
    "template_name_placeholder": "Voer de sjabloonnaam in",
    "message": "Bericht",
    "message_placeholder": "Typ hier uw WhatsApp-bericht.",
    "create_template": "Sjabloon maken",
    "name_required": "Sjabloonnaam is vereist",
    "text_required": "Berichttekst is vereist",
    "fetch_new_templates": "Sjablonen vernieuwen"
  },
  "archivedServices": {
    "servicesBanner": "Er is een nieuwe, verbeterde versie van de diensten—krachtiger, flexibeler en intuïtiever. Uw servicekalenders zijn al gemigreerd. Verken ze nu in het tabblad Services.",
    "archivedServiceCalendars": "Servicekalenders (v1)",
    "check_new_services": "Controleer nieuwe services"
  },
  "tour": {
    "hidden_test_label": "Test",
    "calendar": {
      "edit_calendar": "Kalender bewerken",
      "share_calendar": "Kalender delen",
      "troubleshoot_calendar": "Los problemen met de agenda op",
      "more_options": "Meer opties",
      "edit_calendar_desc": "Manage every Calendar Settings — Fixed Availability , Reminder Configure , Modify wijzigen en meer.",
      "share_calendar_desc": "Copy en Share uw Scheduling Link zodat Booker eenvoudig kan schedule met You",
      "troubleshoot_calendar_desc": "Ontdek waarom een tijdsperiode niet wordt weergegeven en bekijk potentieel oorzaken in het overzicht voor probleemoplossing.",
      "more_options_desc": "Access aanvullende Settings en activities om je agenda te Manage .",
      "read_permissions": {
        "share_description": "Geef anderen toegang door de kalenderlink te delen of de machtigingen aan te passen.",
        "troubleshoot_description": "Identificeer problemen zoals synchronisatiefouten of ontbrekende gebeurtenissen en los ze op voor een soepele werking."
      },
      "next": "Volgende",
      "start_over": "Begin opnieuw",
      "all_set": "Helemaal klaar!",
      "previous": "Vorige"
    }
  },
  "emailTemplate": {
    "select_editing_experience": "Selecteer uw bewerkingservaring",
    "select_editing_experience_desc": "Kies ervoor om te bouwen met behulp van onze visuele ontwerpeditor voor slepen en neerzetten of onze krachtige code-editor.",
    "design_editor": "Ontwerpeditor",
    "design_editor_desc": "Visueel bewerken met slepen en neerzetten.",
    "code_editor": "Code-editor",
    "code_editor_desc": "HTML-bewerking met uitgebreide functies.",
    "text_editor": "Tekstverwerker zonder opmaak",
    "text_editor_desc": "Eenvoudige, schone, no-nonsense tekstbewerking.",
    "email_text_block": "Email kan ook worden Created Via Body Block. ",
    "select": "Selecteren",
    "new_template": "Nieuwe sjabloon",
    "email_block": "E-mail kan ook worden gemaakt met een tekstblok.",
    "fetch_new_templates": "Nieuwe sjablonen ophalen"
  },
  "quick_tips": {
    "meeting_details": {
      "clear_name_and_description": "Gebruik een duidelijke vergadernaam en beschrijving, zodat boekers precies weten wat ze inplannen.",
      "groups_share_link": "Groepen stellen u in staat om één boekingslink te delen voor meerdere kalenders, zodat klanten kunnen kiezen en boeken uit de beschikbare opties."
    },
    "staff_location": {
      "custom_location": "Kies 'Aangepast' als vergaderlocatie om een adres of link van uw keuze in te voeren.",
      "ask_booker_location": "Wanneer 'Vraag de boeker' is geselecteerd, wordt de boeker gevraagd om de vergaderlocatie in te voeren tijdens het boeken",
      "round_robin_priority": "Prioriteitsinstellingen bepalen hoe vergaderingen worden toegewezen wanneer er meerdere medewerkers beschikbaar zijn.",
      "connect_video_integrations": "Verbind videoconferentie-integraties vanuit de kalenderinstellingen → Verbindingen voordat u deze als vergaderlocatie selecteert."
    },
    "availability": {
      "staff_availability_required": "Vergaderingen kunnen alleen worden geboekt als er minstens één geselecteerde medewerker beschikbaar is.",
      "use_precreated_schedule": "U kunt een vooraf ingesteld beschikbaarheidsrooster gebruiken vanuit de kalenderinstellingen → Beschikbaarheid, of een aangepast rooster maken specifiek voor deze kalender.",
      "timezone_in_schedule": "De tijdzone voor vergaderingen wordt ingesteld binnen de geselecteerde beschikbaarheidsschema.",
      "event_24_hours": "Om een kalender 24 uur per dag beschikbaar te maken, stelt u het tijdsbereik in van 12 uur 's ochtends tot 12 uur 's ochtends."
    },
    "booking_rules": {
      "apply_to_all_meetings": "Boekingsregels zijn van toepassing op alle vergaderingen in deze kalender, ongeacht de beschikbaarheid van het personeel.",
      "minimum_scheduling_notice": "Verhoog de minimale planningsmelding om last-minute boekingen te voorkomen.",
      "maximum_bookings_per_slot": "Gebruik het maximale aantal boekingen per tijdsperiode om te bepalen hoeveel vergaderingen tegelijkertijd kunnen plaatsvinden."
    },
    "forms": {
      "custom_contact_fields": "U kunt aangepaste contactpersoonsvelden opnemen in zowel formulierberichten als formulier-URL's.",
      "create_custom_form": "Maak om meer informatie te verzamelen een aangepast formulier aan via Sites → Formulieren → Builder en gebruik het met deze kalender."
    },
    "payments": {
      "collected_during_booking": "Betalingen worden tijdens het boeken geïnd en moeten voltooid zijn voordat de vergadering wordt bevestigd.",
      "payment_description": "Gebruik de betalingsomschrijving om duidelijk uit te leggen waarvoor de kosten zijn."
    },
    "notifications": {
      "review_policies": "Controleer het annulerings- en herboekingsbeleid om last-minute wijzigingen te voorkomen.",
      "use_workflows": "Voor geavanceerde automatisering gebruikt u Workflows met de trigger voor geboekte afspraken."
    },
    "customizations": {
      "preview_widget": "Bekijk de widget om te controleren of deze overeenkomt met uw merk en boekingsproces.",
      "update_widget_language": "De taalinstellingen voor de widget kunnen worden aangepast via Instellingen → Kalenders → Voorkeuren."
    },
    "connections": {
      "google_organic_booking": "Het instellen van Google organische boeking stelt deze kalender in staat om boekingen rechtstreeks vanuit Google Zoeken te ontvangen.",
      "external_sync_event": "Alleen de kalender die onder Externe Sync is geselecteerd, wordt gebruikt om gebeurtenissen voor deze kalender op te halen en te verzenden."
    },
    "equipments": {
      "room_definition": "Een 'ruimte' kan elke locatie vertegenwoordigen waar diensten worden verleend. Dit kunnen fysieke ruimtes en/of speciale stations zijn. Bijv.: pedicurestation.",
      "equipment_definition": "Beschouw 'uitrusting' als elk hulpmiddel of apparaat dat bedrijven gebruiken om afspraken na te komen. Dit kunnen machines, apparaten of zelfs stoelen zijn."
    }
  },
  "aria_labels": {
    "sticky_contacts": "Vastgezette contactpersonen",
    "consent_form": "Toestemmingsformulier",
    "enable_guests": "Gasten inschakelen",
    "auto_confirm": "Automatisch bevestigen",
    "should_accept_payment": "Moet betaling accepteren",
    "collect_deposit": "Aanbetaling verzamelen",
    "enable_charge_guests": "Gasten in rekening brengen inschakelen",
    "enable_coupon": "Coupon inschakelen",
    "payment_live": "Betaling live",
    "add_availability_hour": "Beschikbaarheidsuur toevoegen",
    "remove_availability_hour": "Beschikbaarheidsuur verwijderen",
    "copy_availability_hour": "Beschikbaarheidsuur kopiëren",
    "close_modal": "Modal afsluiten",
    "add_custom_slot": "Aangepaste tijdsperiode toevoegen",
    "remove_custom_slot": "Aangepaste tijdsperiode verwijderen",
    "edit_custom_slot": "Aangepaste tijdsperiode bewerken",
    "update_frequency": "Updatefrequentie",
    "show_calendar_title": "Kalendertitel weergeven",
    "show_calendar_description": "Kalenderbeschrijving tonen.",
    "show_calendar_details": "Kalendergegevens weergeven",
    "allow_reschedule": "Opnieuw inplannen toestaan",
    "allow_cancellation": "Annuleren toestaan",
    "category_actions": "Categorie-acties",
    "show_seats_per_slot": "Toon beschikbare plaatsen per tijdvenster",
    "add_more": "Meer toevoegen",
    "same_user_assignment_toggle": "Dezelfde gebruiker toewijzen inschakelen/uitschakelen"
  },
  "placeholders": {
    "pixel_id": "Pixel-ID",
    "select_one": "Selecteer één optie",
    "meeting_location": "Vergaderlocatie",
    "schedule_meeting": "Vergadering inplannen",
    "notes": "Notities",
    "select_users": "Gebruikers selecteren",
    "please_select": "Maak een keuze"
  },
  "alt_text": {
    "payment_provider": "Betalingsprovider",
    "no_calendars": "Geen kalenders",
    "date_specific_hours": "datumspecifieke-uren",
    "custom_widget_image": "Afbeelding aangepaste widget",
    "service_calendar": "Servicekalender",
    "event_calendar": "Evenementenkalender",
    "round_robin_booking": "Round-robin-boeking",
    "class_booking": "Boeking van klassen",
    "collective_booking": "Collectieve boeking",
    "calendar_cover_image": "Omslagafbeelding kalender ",
    "email_notification_switch": "Schakelaar e-mailnotificatie",
    "email_template_icon": "Pictogram e-mailsjabloon",
    "in_app_notification_switch": "Schakelaar voor meldingen in app",
    "sms_notification_switch": "Schakelaar sms-notificatie",
    "whatsapp_notification_switch": "Schakelaar WhatsApp-notificatie",
    "no_service_found": "Geen services gevonden",
    "no_group_found": "Geen groepen gevonden",
    "sync_icon": "Synchronisatiepictogram",
    "sync_type": "Synchronisatietype",
    "test1": "test1",
    "test2": "test2"
  },
  "tooltips": {
    "text_color": "Tekstkleur",
    "background_color": "Achtergrondkleur",
    "strikethrough": "Doorhalen",
    "superscript": "Superscript",
    "subscript": "Subscript",
    "inline_code_block": "Inline codeblok",
    "code_block": "Codeblok",
    "block_quote": "Blokcitaat",
    "more": "Meer",
    "upload": "Uploaden",
    "image_upload_tooltip": "PNG, JPEG, JPG of GIF (max. afmetingen 180x180px | max. grootte 2,5 MB)",
    "custom_values": "aangepaste waarden",
    "text_wrap": "Tekstterugloop",
    "trigger_links": "triggerlinks",
    "text_align": "Tekstuitlijning"
  },
  "labels": {
    "reset_style": "Stijl terugzetten",
    "reset_document_style": "Documentstijl terugzetten",
    "source_code": "Broncode",
    "success": "Gelukt",
    "edit": "Bewerken",
    "submit": "Opslaan",
    "cancel": "Annuleren",
    "payment": "Betaling",
    "here_is_the_link": "Hier is de link:",
    "here_is_the_embed_code": "Hier is de insluitcode:",
    "service_calendar": "Servicekalender",
    "collective_booking": "Gezamenlijke boeking",
    "class_booking": "Boeking van klassen",
    "round_robin_booking": "Round-robin-boeking",
    "event_calendar": "Evenementenkalender",
    "personal_booking": "Persoonlijke boeking",
    "service_booking": "Serviceboeking",
    "calendar_id": "Agenda-ID"
  },
  "validation_messages": {
    "calendar_group_name_required": "De naam van de kalendergroep is vereist.",
    "calendar_group_description_required": "De beschrijving van de kalendergroep is vereist.",
    "slug_required": "Slug is vereist.",
    "slug_not_valid": "Deze slug is ongeldig.",
    "slug_already_taken": "Deze slug is al in gebruik.",
    "error_validating_slug": "Fout bij het valideren van slug.",
    "please_enter_name": "Voer een naam in.",
    "room_name_required": "Naam van ruimte is vereist",
    "equipment_name_required": "Naam van uitrusting is vereist.",
    "subject_required": "Onderwerp is verplicht.",
    "this_is_required": "Dit is vereist.",
    "calendar_group_slug_required": "De naam (slug) van de kalendergroep is vereist.",
    "capacity_mandatory": "Capaciteit is vereist.",
    "capacity_cannot_be_zero": "Capaciteit kan niet nul zijn.",
    "capacity_should_be_a_number": "Capaciteit moet een getal zijn.",
    "capacity_cannot_be_negative": "Capaciteit kan niet negatief zijn.",
    "capacity_should_be_a_whole_number": "Capaciteit moet een geheel getal zijn.",
    "quantity_mandatory": "Aantal is vereist",
    "quantity_cannot_be_zero": "Aantal kan niet nul zijn.",
    "quantity_should_be_a_number": "Aantal moet een getal zijn.",
    "quantity_cannot_be_negative": "Aantal kan niet negatief zijn.",
    "quantity_should_be_a_whole_number": "Aantal moet een geheel getal zijn.",
    "quantity_cannot_be_less_than_out_of_service_equipments": "Aantal mag niet minder zijn dan het aantal buiten gebruik zijnde apparatuur.",
    "out_of_service_value_should_be_a_number": "De buiten gebruik-waarde moet een getal zijn.",
    "out_of_service_cannot_be_negative": "Buiten gebruik kan niet negatief zijn",
    "out_of_service_equipments_qty": "Buiten gebruik gestelde apparatuur kan niet meer zijn dan het werkelijke aantal apparaten.",
    "out_of_service_whole_number": "Buiten gebruik moet een geheel getal zijn.",
    "slot_duration_required": "Duur van de tijdvak is vereist.",
    "slot_duration_integer": "De duur van het tijdvak moet een geheel getal zijn.",
    "meeting_duration_validation": "De duur van de vergadering moet tussen 1 minuut en 12 uur liggen",
    "seats_class_required": "Zetels per klas zijn vereist.",
    "seats_class_integer": "Zetels per klas moeten een geheel getal zijn.",
    "seats_class_validation": "Dit mag niet groter zijn dan 9999 of minder dan 0.",
    "meeting_location_required": "Vergaderlocatie is vereist.",
    "meeting_location_empty": "Voer een waarde in voor alle locatietypen.",
    "meeting_location_duplicate": "Dubbele waarde voor hetzelfde locatietype is niet toegestaan.",
    "meeting_location_booker_multiple": "Ask the Booker is niet toegestaan voor meerdere teamleden."
  },
  "custom_values": {
    "assigned_user": "Toegewezen gebruiker",
    "full_name": "Volledige naam",
    "first_name": "Voornaam",
    "last_name": "Achternaam",
    "email": "E-mail",
    "phone": "Telefoon",
    "twilio_phone": "Twilio-telefoon",
    "account": "Account",
    "name": "Naam",
    "full_address": "Volledig adres",
    "city": "Stad",
    "state": "Provincie",
    "country": "Land",
    "postal_code": "Postcode",
    "contact": "Contact",
    "address1": "Adres 1",
    "timezone": "Tijdzone",
    "user": "Gebruiker",
    "appointment": "Afspraak",
    "start_date_time": "Startdatum en -tijd",
    "start_date": "Begindatum",
    "start_time": "Begintijd",
    "end_date_time": "Einddatum en -tijd",
    "end_date": "Einddatum",
    "end_time": "Eindtijd",
    "meeting_location": "Vergaderlocatie"
  },
  "meeting_location_types": {
    "zoom": "Zoom",
    "google_meet": "Google Meet",
    "phone": "Telefoon",
    "full_address": "Volledig adres",
    "microsoft_teams": "Microsoft Teams",
    "custom": "Aangepast"
  },
  "duration_units": {
    "minutes": "Minuten",
    "hours": "Uur"
  },
  "widget_styles": {
    "classic": "Klassiek",
    "neo": "Neo"
  },
  "feature_labels": {
    "service_menu": "Servicemenu",
    "rooms": "Ruimtes",
    "equipments": "Uitrusting"
  },
  "lsa": {
    "categories": {
      "accountant": "Boekhouding",
      "acupuncturist": "Acupunctuur",
      "air_duct_cleaner": "Reiniging van luchtkanalen",
      "alcohol_treatment": "Diensten voor behandeling van alcoholisme",
      "animal_shelter": "Reddingsdiensten voor dieren",
      "appliance_repair": "Apparaatreparatie",
      "architect": "Architectuur",
      "assisted_living": "Diensten voor begeleid wonen",
      "babysitter": "Oppassen",
      "bankruptcy_lawyer": "Faillissementsrecht",
      "beauty_school": "Schoonheidsschool",
      "business_lawyer": "Bedrijfsrecht",
      "car_repair": "Automatische diensten",
      "carpenter": "Timmerwerk",
      "carpet_cleaning": "Tapijtreiniging",
      "child_care": "Kinderopvangdiensten",
      "chiropractor": "Chiropractische diensten",
      "cleaning_service": "Huishoudelijke schoonmaak",
      "contract_lawyer": "Contractenrecht",
      "countertop_pro": "Aanrechtdiensten",
      "criminal_lawyer": "Strafrecht",
      "dance_instructor": "Dansinstructie",
      "disability_lawyer": "Gehandicaptenrecht",
      "driving_instructor": "Rijinstructie",
      "dui_lawyer": "Wet op rijden onder invloed",
      "electrician": "Elektrisch",
      "energy_efficiency_pro": "Diensten voor energie-efficiëntie",
      "estate_lawyer": "Erfrecht",
      "event_planner": "Evenementenplanning",
      "family_lawyer": "Familierecht",
      "fencing_pro": "Schermen",
      "financial_planner": "Financiële planning",
      "first_aid_trainer": "EHBO-training",
      "flooring_pro": "Vloeren",
      "foundation_pro": "Basisprincipes",
      "funeral_home": "Uitvaartdiensten",
      "garage_door_pro": "Garagedeur",
      "general_contractor": "Woningverbetering",
      "handyman": "Klusjesman",
      "home_inspector": "Woninginspectie",
      "home_security": "Diensten voor woningbeveiliging",
      "home_theater": "Thuisbioscoopdiensten",
      "hvac": "HVAC",
      "immigration_lawyer": "Immigratiewet",
      "interior_designer": "Interieurontwerp",
      "ip_lawyer": "Intellectueel eigendomsrecht",
      "junk_removal": "Afvalverwijdering",
      "labor_lawyer": "Arbeidsrecht",
      "landscaper": "Tuinieren",
      "language_instructor": "Taalinstructie",
      "lawn_care": "Gazononderhoud",
      "litigation_lawyer": "Procesrecht",
      "locksmith": "Slotenmaker",
      "malpractice_lawyer": "Aansprakelijkheidsrecht",
      "massage_center": "Massagediensten",
      "massage_school": "Massageschool",
      "mover": "Bezig met verplaatsen",
      "nursing_home": "Verpleeghuisdienst",
      "painter": "Schilderen",
      "personal_injury_lawyer": "Letselschaderecht",
      "personal_trainer": "Persoonlijke training",
      "pest_control": "Ongediertebestrijding",
      "pet_adoption": "Services voor adoptie van huisdieren",
      "pet_boarding": "Dierenopvang",
      "pet_grooming": "Dierenverzorging",
      "pet_trainer": "Huisdierentraining",
      "photographer": "Fotografie",
      "plumber": "Loodgieterswerk",
      "pool_cleaner": "Zwembadreiniging",
      "pool_contractor": "Zwembadcontractering",
      "preschool": "Kleuteronderwijs",
      "psychologist": "Psychologische diensten",
      "real_estate_agent": "Onroerend goed",
      "real_estate_lawyer": "Vastgoedrecht",
      "rehab": "Revalidatiediensten",
      "roofer": "Dakbedekking",
      "sewage_pro": "Diensten voor rioleringssystemen",
      "siding_pro": "Gevelbekleding",
      "smart_home": "Slimme diensten aan huis",
      "snow_removal": "Sneeuwruimdiensten",
      "spa": "Spadiensten",
      "tax_lawyer": "Belastingrecht",
      "tax_specialist": "Fiscale dienstverlening",
      "therapist": "Therapie",
      "towing_pro": "Pechhulp",
      "traffic_lawyer": "Verkeersrecht",
      "tree_service": "Boomverzorgingsdiensten",
      "tutor": "Bijles",
      "upholstery_cleaner": "Meubelreiniging",
      "veterinarian": "Veterinaire diensten",
      "videographer": "Videodiensten",
      "water_damage": "Diensten bij waterschade",
      "weight_loss_service": "Diensten voor gewichtsverlies",
      "window_cleaner": "Glasbewassing",
      "window_repair": "Diensten voor ruiten",
      "windshield_repair_pro": "Automatisch glas",
      "yoga_instructor": "Yoga"
    },
    "job_types": {
      "accountant_other": "Anders",
      "bankruptcy_tax_litigation": "Fiscale geschillen over faillissementen",
      "bookkeeping": "Boekhouding",
      "business_consulting": "Bedrijfsconsultancy",
      "debt_collection_relief": "Schuldhulpverlening",
      "irs_representation_resolution": "Fiscale vertegenwoordiging en probleemoplossing",
      "payroll": "Salarisadministratie",
      "tax_planning_business": "Zakelijke belastingplanning",
      "tax_planning_individual": "Particuliere belastingplanning",
      "tax_return_business": "Zakelijke belastingaangifte",
      "tax_return_individual": "Particuliere belastingaangifte",
      "trusts_estates_accounting": "Boekhouding voor trusts en nalatenschappen",
      "acupressure": "Acupressuur",
      "acupuncture": "Acupunctuur",
      "acupuncturist_other": "Anders",
      "cupping": "Cupping",
      "gua_sha": "Gua Sha",
      "heat_therapy": "Warmtetherapie",
      "herbal_therapy": "Kruidengeneeskunde",
      "infrared_therapy": "Infraroodtherapie",
      "moxibustion": "Moxibustie",
      "qigong": "Qigong",
      "shiatsu": "Shiatsu",
      "tui_na": "Tui Na",
      "air_duct_cleaning": "Reiniging van luchtkanalen",
      "air_duct_filter_replacement": "Filters vervangen",
      "air_duct_other": "Anders",
      "dryer_vent_cleaning": "Reiniging van drogerafvoer",
      "furnace_cleaning": "Reiniging van oven",
      "indoor_air_quality_testing": "Testen van de luchtkwaliteit binnen",
      "alcohol_treatment_other": "Anders",
      "animal_shelter_cat_adoption": "Kattenadoptie",
      "animal_shelter_dog_adoption": "Hondenadoptie",
      "animal_shelter_other": "Anders",
      "animal_shelter_other_animal_adoption": "Adoptie van andere dieren",
      "animal_shelter_other_veterinary_services": "Andere veterinaire diensten",
      "animal_shelter_spay_neuter": "Steriliseren of castreren",
      "animal_shelter_vaccinations": "Vaccinaties",
      "lost_stray_found_animals": "Verloren, verdwaalde of gevonden dieren",
      "pet_license": "Huisdierlicentie",
      "pet_surrender": "Huisdieroverdracht",
      "appliance_other": "Anders",
      "repair_dishwasher": "Vaatwasser repareren",
      "repair_dryer": "Droger repareren",
      "repair_freezer": "Vriezer repareren",
      "repair_microwave": "Magnetron repareren",
      "repair_oven": "Oven repareren",
      "repair_refrigerator": "Koelkast repareren",
      "repair_refrigerator_freezer": "Koelkast / vriezer repareren",
      "repair_stove_cooktop": "Fornuis / kookplaat repareren",
      "repair_stove_cooktop_oven": "Fornuis / kookplaat / oven repareren",
      "repair_washer": "Wasmachine repareren",
      "repair_washer_dryer": "Wasmachine / droger repareren",
      "3d_architectural_rendering": "3D architecturale rendering",
      "adaptive_reuse_historical_renovation": "Adaptief hergebruik en historische renovatie",
      "architect_other": "Anders",
      "architectural_designing": "Architectonisch ontwerpen",
      "architectural_engineering": "Bouwkundige engineering",
      "building_code_analysis_permit_coordination": "Codeanalyse en vergunningen",
      "consulting": "Advies",
      "home_building_improvement": "Woningbouw en -verbetering",
      "interior_design_architect": "Interieurontwerp",
      "planning_zoning_approval_assistance": "Goedkeuring van bestemmingsplannen",
      "project_managing_architect": "Projectbeheer",
      "site_master_planning": "Masterplanning van locaties",
      "assisted_living_housekeeping_and_laundry": "Huishouden en wasserij",
      "assisted_living_meal_services": "Maaltijdservices",
      "assisted_living_memory_care": "Geheugenzorg",
      "assisted_living_other": "Anders",
      "assisted_living_rehabilitation_services": "Revalidatiediensten",
      "assisted_living_transportation": "Vervoer",
      "assisted_living_wellness_programs": "Wellnessprogramma's",
      "daily_living_assistance": "Hulp bij het dagelijks leven",
      "medication_management": "Medicatiebeheer",
      "short_term_stays": "Korte verblijven",
      "social_and_recreational_activities": "Recreatieve activiteiten",
      "babysitter_other": "Anders",
      "event_babysitting": "Babysitten bij evenementen",
      "homework_assistance": "Huiswerkbegeleiding",
      "housekeeping_laundry": "Huishouden en wasserij",
      "meal_preparation": "Maaltijdvoorbereiding",
      "nanny_services": "Nannydiensten",
      "overnight_babysitting": "Babysitten 's nachts",
      "pick_up_and_drop_off": "Ophalen en afzetten",
      "shopping_errand": "Winkelen en boodschappen doen",
      "special_needs_care": "Speciale zorg",
      "virtual_babysitting": "Virtueel babysitten",
      "agriculture_bankruptcy": "Landbouwfaillissement",
      "bankruptcy_lawyer_other": "Anders",
      "bankruptcy_litigation": "Geschillen over faillissementen",
      "chapter_11_bankruptcy": "Chapter 11-faillissement",
      "chapter_13_bankruptcy": "Chapter 13-faillissement",
      "chapter_7_bankruptcy": "Chapter 7-faillissement",
      "corporate_bankruptcy": "Bedrijfsfaillissement",
      "creditor_harassment": "Crediteurintimidatie",
      "debt_settlement": "Schuldenregeling",
      "foreclosure_bankruptcy_lawyer": "Executieverkoop",
      "personal_bankruptcy": "Persoonlijk faillissement",
      "repossession": "Terugname",
      "wage_garnishment": "Loonbeslag",
      "beauty_school_barbering": "Barber",
      "beauty_school_business_management": "Bedrijfsbeheer",
      "beauty_school_cosmetology": "Cosmetologie",
      "beauty_school_esthetics": "Esthetiek",
      "beauty_school_hair_cutting": "Haarknippen",
      "beauty_school_hair_design": "Haarontwerp",
      "beauty_school_makeup": "Make-up",
      "beauty_school_massage_therapy": "Massagetherapie",
      "beauty_school_nail_technology": "Nageltechnologie",
      "beauty_school_other": "Anders",
      "beauty_school_retail_training": "Retailtraining",
      "banking_finance_law": "Bankwezen en financiën",
      "business_lawyer_other": "Anders",
      "business_licenses_permits": "Zakelijke licenties en vergunningen",
      "business_litigation": "Zakelijke geschillen",
      "business_taxes": "Zakelijke belastingen",
      "business_transactions_business_lawyer": "Zakelijke transacties",
      "commercial_bankruptcy": "Zakelijk faillissement",
      "commercial_contracts_business_lawyer": "Commerciële contracten",
      "employment_law_business_lawyer": "Arbeidsrecht",
      "incorporation_restructuring": "Oprichting en herstructurering",
      "insurance_law": "Verzekeringsrecht",
      "intellectual_property_law": "Intellectueel eigendomsrecht",
      "mergers_acquisitions_business_lawyer": "Fusies en overnames",
      "partnership_agreements_business_lawyer": "Partnerschapsovereenkomsten",
      "patents_copyrights_trademarks": "Patenten, auteursrechten en handelsmerken",
      "securities_law": "Effectenrecht",
      "shareholder_disputes": "Geschillen met aandeelhouders",
      "air_and_cabin_filter": "Lucht- en cabinefilter",
      "battery": "Batterij",
      "body_and_trim": "Lichaam en trimmen",
      "brakes": "Remmen",
      "car_air_conditioning": "Airconditioning",
      "car_electrical": "Elektrisch",
      "car_repair_other": "Anders",
      "check_engine_light_diagnostic": "Diagnose motorcontrolelampje",
      "exhaust": "Uitlaat",
      "oil_change": "Olie verversen",
      "steering_suspension": "Stuurinrichting / ophanging",
      "tires": "Banden",
      "transmission": "Transmissie",
      "cabinetry": "Kastenbouw",
      "carpenter_other": "Anders",
      "decking": "Terrasplanken",
      "drywalling": "Gipsplaten plaatsen",
      "fencing": "Schermen",
      "general_installations": "Algemene installaties",
      "general_repairs_maintenance": "Algemene reparaties en onderhoud",
      "remodeling": "Renovatie",
      "shelving_storage": "Rekken en opslag",
      "carpet_cleaning_other": "Anders",
      "clean_area_rugs": "Vloerkleden reinigen",
      "clean_carpet": "Tapijt reinigen",
      "clean_drapes_and_curtains": "Voiles en gordijnen reinigen",
      "clean_upholstery": "Bekleding reinigen",
      "remove_pet_stains_and_odors": "Vlekken en geurtjes verwijderen bij huisdieren",
      "after_school_care": "Naschoolse opvang",
      "all_hours_daycare": "Kinderopvang voor alle uren",
      "bilingual_daycare": "Tweetalige kinderopvang",
      "child_care_other": "Anders",
      "drop_in_daycare": "Inloopkinderopvang",
      "full_time_daycare": "Voltijds kinderopvang",
      "in_home_daycare": "Dagopvang aan huis",
      "infant_programs": "Babyprogramma's",
      "part_time_daycare": "Deeltijd kinderopvang",
      "pre_kindergarten_programs": "Programma's voorafgaand aan de kleuterschool",
      "preschool_programs": "Voorschoolse programma's",
      "school_age_programs": "Programma's voor schoolgaande kinderen",
      "special_needs_daycare": "Kinderopvang speciaal onderwijs",
      "summer_daycare": "Zomerdagopvang",
      "toddler_programs": "Peuterprogramma's",
      "weekend_daycare": "Weekendkinderopvang",
      "chiropractor_acupuncture": "Acupunctuur",
      "chiropractor_chiropractic": "Chiropractie",
      "chiropractor_massage_therapy": "Massagetherapie",
      "chiropractor_other": "Anders",
      "diagnosis": "Diagnose",
      "eastern_medicine": "Oosterse geneeskunde",
      "exercise_counseling": "Bewegingsadvies",
      "pain_management": "Pijnbeheer",
      "physical_therapy": "Fysiotherapie",
      "spinal_adjustments": "Rugcorrecties",
      "sports_medicine": "Sportgeneeskunde",
      "cleaner_other": "Anders",
      "deep_clean": "Grondige schoonmaak",
      "moving_clean": "Schoonmaak bij verhuizing",
      "office_clean": "Kantoor schoonmaken",
      "standard_clean": "Normale schoonmaak",
      "assignment_of_contract": "Toewijzing van contract",
      "business_transactions_contract_lawyer": "Zakelijke transacties",
      "commercial_contracts_contract_lawyer": "Commerciële contracten",
      "contract_dispute": "Contractgeschil",
      "contract_lawyer_other": "Anders",
      "contract_negotiation": "Contractonderhandeling",
      "contract_review": "Contractbeoordeling",
      "employment_contracts_contract_lawyer": "Arbeidsovereenkomsten",
      "franchise_agreements": "Franchiseovereenkomsten",
      "mergers_acquisitions_contract_lawyer": "Fusies en overnames",
      "non_disclosure_agreements_contract_lawyer": "Geheimhoudingsovereenkomsten",
      "partnership_agreements_contract_lawyer": "Partnerschapsovereenkomsten",
      "power_of_attorney_contract_lawyer": "Volmacht",
      "security_agreements": "Beveiligingsovereenkomsten",
      "warranties": "Garanties",
      "bathroom_countertops": "Badkamerbladen",
      "bathroom_wall_panels": "Badkamerwandpanelen",
      "countertop_design": "Aanrechtbladontwerp",
      "countertop_installation": "Aanrechtbladinstallatie",
      "countertop_pro_other": "Anders",
      "fireplace_facade": "Openhaardgevel",
      "granite_countertops": "Granieten aanrechtbladen",
      "kitchen_countertops": "Keukenwerkbladen",
      "kitchen_wall_panels": "Keukenwandpanelen",
      "laminate_countertops": "Werkbladen van laminaat",
      "marble_countertops": "Marmeren werkbladen",
      "quartz_countertops": "Kwarts werkbladen",
      "remodeling_countertop_pro": "Renovatie",
      "repair_maintenance_countertop_pro": "Reparatie en onderhoud",
      "stone_slab_countertops": "Stenen werkbladen",
      "tile_countertops": "Tegelwerkbladen",
      "corporate_representation": "Bedrijfsvertegenwoordiging",
      "criminal_immigration_defense": "Strafrechtelijke Immigratieverdediging",
      "criminal_lawyer_other": "Anders",
      "domestic_violence": "Huiselijk geweld",
      "drug_possession": "Drugsbezit",
      "duis_reckless_driving": "Rijden onder invloed en roekeloos rijden",
      "expungement": "Uitzetting",
      "federal_crimes": "Federale misdrijven",
      "felonies": "Zware misdrijven",
      "petty_crimes_misdemeanors": "Kleine misdrijven en overtredingen",
      "restraining_orders": "Huisverboden",
      "sex_offenses": "Seksuele misdrijven",
      "three_strikes_law": "Three-strikes-wet",
      "dance_instructor_african": "Afrikaans",
      "dance_instructor_ballet": "Ballet",
      "dance_instructor_ballroom": "Balzaal",
      "dance_instructor_belly": "Buik",
      "dance_instructor_bollywood": "Bollywood",
      "dance_instructor_contemporary": "Modern",
      "dance_instructor_folk_traditional": "Folk en traditioneel",
      "dance_instructor_hip_hop": "Hip Hop",
      "dance_instructor_jazz": "Jazz",
      "dance_instructor_kids_classes": "Lessen voor kinderen",
      "dance_instructor_latin": "Latijn",
      "dance_instructor_modern": "Modern",
      "dance_instructor_other": "Anders",
      "dance_instructor_tap": "Tik",
      "dance_instructor_wedding": "Bruiloft",
      "disability_hearings": "Hoorzittingen over handicaps",
      "disability_lawyer_other": "Anders",
      "long_term_disability": "Langdurige arbeidsongeschiktheid",
      "short_term_disability": "Kortdurende arbeidsongeschiktheid",
      "social_security_disability_insurance": "Arbeidsongeschiktheidsverzekering vanuit sociale zekerheid",
      "ssa_claim_reconsideration": "Heroverweging van de SSA-claim",
      "ssa_disability_appeals": "Bezwaren arbeidsongeschiktheid SSA",
      "ssa_disability_applications": "Aanvragen arbeidsongeschiktheid SSA",
      "ssa_disability_benefits": "SSA-uitkeringen voor arbeidsongeschiktheid",
      "ssa_family_benefits": "SSA-uitkeringen voor gezinsleden",
      "ssa_impairment_listings": "SSA-beperkingenlijsten",
      "supplemental_security_income": "Aanvullende sociale zekerheid",
      "veterans_disability_benefits": "Uitkeringen voor veteranen met een handicap",
      "workers_compensation_disability_lawyer": "Werknemerscompensatie",
      "behind_the_wheel_lessons": "Lessen achter het stuur",
      "commercial_license_training": "Commerciële licentiecursussen",
      "defensive_driving_lessons": "Lessen defensief rijden",
      "drivers_education_classes": "Rijopleidingen",
      "driving_instructor_other": "Anders",
      "manual_transmission_lessons": "Lessen over handgeschakelde versnellingsbakken",
      "motorcycle_lessons": "Motorrijlessen",
      "traffic_school": "Verkeersschool",
      "dui_dwi_dui_lawyer": "DUI/DWI",
      "dui_injuries_dui_lawyer": "DUI met letsel",
      "dui_lawyer_other": "Anders",
      "dui_with_accident": "DUI met ongeval",
      "felony_dui": "Zware overtreding DUI",
      "invalid_tests": "Vervallen tests",
      "multiple_offenses": "Meerdere overtredingen",
      "reckless_driving_dui_lawyer": "Roekeloos rijden",
      "underage_dui": "DUI door minderjarigen",
      "electric_car_charger": "Lader voor elektrische auto installeren",
      "electrician_other": "Anders",
      "electrician_remodeling": "Verbouwen",
      "install_fan": "Ventilator installeren",
      "install_ground_wire": "Aardingsdraad installeren",
      "install_light_fixtures": "Lichtarmaturen installeren",
      "install_outdoor_lighting": "Buitenverlichting installeren",
      "install_outlets_switches": "Stopcontacten of schakelaars installeren",
      "install_security_system": "Beveiligingssysteem installeren",
      "relocate_outlets_switches": "Stopcontacten of schakelaars verplaatsen",
      "repair_fan": "Ventilator repareren",
      "repair_light_fixtures": "Lichtarmaturen repareren",
      "repair_outlets_switches": "Stopcontacten of schakelaars repareren",
      "repair_panel": "Paneel repareren",
      "replace_upgrade_panel": "Paneel vervangen of upgraden",
      "restore_power": "Stroom herstellen",
      "energy_efficiency_pro_other": "Anders",
      "charitable_giving": "Liefdadigheidsbijdrage",
      "contests_litigation": "Geschillen / rechtszaken",
      "deeds": "Aktes",
      "estate_lawyer_other": "Anders",
      "estate_planning_lawyer": "Vermogensplanning",
      "guardianship_estate_lawyer": "Voogdij",
      "medical_power_of_attorney": "Medische volmacht",
      "power_of_attorney_estate_lawyer": "Volmacht",
      "probate_estate_lawyer": "Erfrechtadvocaat",
      "trusts": "Trusts",
      "wills": "Testamenten",
      "anniversary_planner": "Jubileum",
      "baby_shower_planner": "Babyshower",
      "bar_and_bat_mitzvah_planner": "Bar en Bat Mitswa",
      "birthday_party": "Verjaardagsfeestje",
      "children_party": "Kinderfeestje",
      "corporate_and_conference_planner": "Zakelijk en conferentie",
      "event_planner_other": "Anders",
      "quinceanera_planner": "Quinceanera",
      "religious_event": "Religieus evenement",
      "retirement_party": "Pensioenfeest",
      "school_event": "Schoolevenement",
      "theme_party": "Themafeest",
      "wedding_and_engagement_planner": "Bruiloft en verloving",
      "adoption": "Adoptie",
      "child_support": "Kinderbijslag",
      "contested_divorce": "Betwiste echtscheiding",
      "debt_division": "Schuldenverdeling",
      "family_lawyer_other": "Anders",
      "guardianship_family_lawyer": "Voogdij",
      "mediation_family_lawyer": "Mediation",
      "modifications_of_orders": "Wijziging van bestellingen",
      "parent_timesharing": "Timesharing voor ouders",
      "paternity": "Vaderschap",
      "prenuptial_postnuptial_agreements": "Huwelijkse voorwaarden en huwelijkscontracten",
      "probate_family_lawyer": "Erfrecht",
      "property_divisions": "Eigendomsscheiding",
      "protective_orders_domestic_violence_issues": "Huisverboden",
      "spousal_support_alimony": "Partneralimentatie en alimentatie",
      "uncontested_divorce": "Onbetwiste echtscheiding",
      "custom_construction": "Aangepaste constructie",
      "fence_design": "Ontwerp van omheining",
      "fencing_other": "Anders",
      "installation_fencing_pro": "Installatie van omheining",
      "repairs_maintenance_fencing_pro": "Reparaties en onderhoud",
      "education_savings": "Besparingen op onderwijs",
      "estate_financial_planning": "Vermogensplanning",
      "financial_planning": "Financiële planning",
      "financial_planning_other": "Anders",
      "home_purchase": "Aankoop van een woning",
      "insurance": "Verzekering",
      "investment_advising": "Beleggingsadvies",
      "retirement_savings": "Pensioen",
      "tax_planning": "Fiscale planning",
      "advanced_cardiac_life_support": "Geavanceerde cardiale beademing",
      "aed_defibrillator": "AED - Defibrillator",
      "basic_life_support": "Eenvoudige beademing",
      "cpr": "CPR",
      "first_aid": "Eerste hulp",
      "first_aid_trainer_other": "Anders",
      "pediatric_advanced_life_support": "Pediatrische geavanceerde beademing",
      "pediatric_cpr_first_aid": "Pediatrische reanimatie en eerste hulp",
      "pet_cpr_first_aid": "Reanimatie en eerste hulp bij huisdieren",
      "wilderness_first_aid": "Eerste hulp in de wildernis",
      "baseboards": "Plinten",
      "carpet": "Tapijt",
      "flooring_other": "Anders",
      "hardwood": "Hardhout",
      "installation_flooring_pro": "Vloeren installeren",
      "marble": "Marmer",
      "polishing": "Vloer polijsten",
      "refinishing": "Vloerrenovatie",
      "repair_maintenance_flooring_pro": "Vloerreparatie en -onderhoud",
      "stair_flooring": "Trapbekleding",
      "tile": "Tegel",
      "wood_floor_sanding": "Schuurwerk voor houten vloeren",
      "basement_waterproofing": "Kelder waterdicht maken",
      "crawl_spaces": "Fundering van kruipruimte",
      "foundation_drainage": "Funderingsdrainage",
      "foundation_installation": "Installatie fundering",
      "foundation_pro_other": "Anders",
      "foundation_raising": "Funderingsverhoging",
      "repairs_maintenance_foundation_pro": "Reparaties en onderhoud",
      "slab_foundation": "Plaatfundering",
      "steel_pier_pilings": "Stalen pierpalen",
      "water_moisture_control": "Water- en vochtbeheer",
      "burials": "Begrafenissen",
      "caskets": "Doodskisten",
      "cremation": "Crematie",
      "funeral_home_flowers": "Bloemen",
      "funeral_home_other": "Anders",
      "funeral_home_transportation_transfers": "Vervoer en transfers",
      "funeral_home_veteran_services": "Diensten voor veteranen",
      "funerals": "Begrafenissen",
      "gravestones": "Grafstenen",
      "grief_services": "Rouwdiensten",
      "memorials": "Gedenktekens",
      "urns": "Urnen",
      "garage_door_other": "Anders",
      "general_maintenance": "Algemeen onderhoud",
      "install_garage_door": "Garagedeur installeren",
      "install_opener": "Opener installeren",
      "repair_cables": "Kabels repareren",
      "repair_garage_door": "Garagedeur repareren",
      "repair_gate": "Poort repareren",
      "repair_rollers_tracks": "Rollen en rupsbanden repareren",
      "replace_door_panels": "Deurpanelen vervangen",
      "replace_opener": "Opener vervangen",
      "replace_springs": "Veren vervangen",
      "accessory_buildings": "Bijgebouwen",
      "bathroom_remodel": "Badkamer verbouwen",
      "decks_patio": "Terrassen en patio",
      "exterior_finishing": "Buitenafwerking",
      "foundations_concrete": "Funderingen en Beton",
      "general_contractor_commercial_projects": "Commerciële projecten",
      "general_contractor_other": "Anders",
      "home_addition": "Woninguitbreiding",
      "home_building": "Woningbouw",
      "home_remodel_renovation": "Woningrenovatie en verbouwing",
      "interior_finishing": "Interieurafwerking",
      "kitchen_remodel": "Keukenrenovatie",
      "roofing": "Dakbedekking",
      "assemble_furniture": "Meubels samenstellen",
      "clean_gutters": "Dakgoten schoonmaken",
      "handyman_other": "Anders",
      "install_drywall": "Gipsplaat installeren",
      "install_flooring": "Vloeren leggen",
      "install_tile": "Tegel installeren",
      "install_water_fixtures": "Waterarmaturen installeren",
      "mount_tv": "TV monteren",
      "paint_indoors": "Binnen schilderen",
      "paint_outdoors": "Buiten schilderen",
      "repair_drywall": "Gipsplaten repareren",
      "repair_flooring": "Vloer repareren",
      "repair_water_fixtures": "Waterinstallaties repareren",
      "replace_tile": "Tegel vervangen",
      "buyer_seller_inspection": "Koper-verkoperinspectie",
      "commercial_properties": "Commercieel vastgoed",
      "fire_safety": "Brandveiligheid",
      "fireplace_chimney": "Open haard en schoorsteen",
      "full_home_inspection": "Volledige woninginspectie",
      "home_inspector_electrical": "Elektrisch",
      "home_inspector_foundation": "Fundering",
      "home_inspector_hvac": "HVAC",
      "home_inspector_mold": "Schimmel",
      "home_inspector_new_construction": "Nieuwbouw",
      "home_inspector_other": "Anders",
      "home_inspector_plumbing": "Loodgieterswerk",
      "home_inspector_roof": "Dak",
      "home_inspector_structural": "Structureel",
      "home_warranty": "Woninggarantie",
      "water_testing": "Watertesten",
      "well_or_septic_system": "Put of septisch systeem",
      "wood_insects": "Hout en insecten",
      "access_control": "Toegangscontrole",
      "alarm_systems": "Alarmsystemen",
      "commercial_security_systems": "Commerciële beveiligingssystemen",
      "fire_smoke_detection": "Brand- en rookdetectie",
      "home_security_doors": "Deuren",
      "home_security_locks": "Vergrendelingen",
      "home_security_other": "Anders",
      "home_security_windows": "Vensters",
      "monitoring_services": "Monitoringsdiensten",
      "residential_security_systems": "Beveiligingssystemen voor woningen",
      "smart_home_integration": "Smart home-integratie",
      "video_surveillance": "Videobewaking",
      "audio_video_installation": "Audio- en video-installatie",
      "commercial_projects": "Commerciële projecten",
      "home_theater_design": "Ontwerp van thuisbioscoop",
      "home_theater_lighting": "Verlichting",
      "home_theater_other": "Anders",
      "home_theater_smart_home_integration": "Smart home-integratie",
      "install_tv": "TV installeren",
      "network_it_services": "Netwerk- en IT-diensten",
      "outdoor_installations": "Buiteninstallaties",
      "soundproofing": "Geluidsisolatie",
      "whole_house_audio_video": "Audio en video voor het hele huis",
      "ac_maintenance": "AC-onderhoud",
      "clean_ducts_vents": "Kanalen en ventilatieopeningen schoonmaken",
      "ductless_heating_and_ac_services": "Diensten voor verwarmingen en airconditionings zonder leidingen",
      "heating_maintenance": "Verwarmingsonderhoud",
      "hvac_maintenance": "HVAC-onderhoud",
      "hvac_other": "Anders",
      "install_ac": "Installeren airconditioning",
      "install_ducts_vents": "Leidingen en ventilatieopeningen installeren",
      "install_heating_system": "Verwarmingssysteem installeren",
      "install_thermostat": "Thermostaat installeren",
      "repair_ac": "Airco repareren",
      "repair_ducts_vents": "Reparatie van leidingen en ventilatieopeningen",
      "repair_heating_system": "Verwarmingssysteem repareren",
      "repair_hvac": "HVAC repareren",
      "repair_thermostat": "Thermostaat repareren",
      "asylum": "Asiel",
      "citizenship": "Burgerschap",
      "deportation": "Deportatie",
      "family_based_immigration": "Familiegebonden immigratie",
      "green_card": "Green card",
      "immigration_lawyer_other": "Anders",
      "investment_visa": "Investeringsvisum",
      "outbound_work_permits": "Uitgaande werkvergunningen",
      "student_visa": "Studentenvisum",
      "visitor_visa": "Bezoekersvisum",
      "work_visa": "Werkvisum",
      "appliance_selection": "Selectie van apparaten",
      "cabinetry_molding_hardware_design": "Ontwerp van kasten en hardware",
      "decorating": "Decoreren",
      "door_design": "Ontwerp van deuren",
      "exterior_building_design": "Ontwerp van exterieur van gebouwen",
      "flooring_selection": "Selectie van vloeren",
      "interior_designer_other": "Anders",
      "landscaping_design": "Tuinontwerp",
      "lighting_design": "Verlichtingsontwerp",
      "multifamily_housing_design": "Opmaak van meergezinswoningen",
      "room_planning": "Ruimteplanning",
      "stone_brick_stucco_design": "Onwerp van steen, baksteen en stucwerk",
      "window_design": "Vensterontwerp",
      "advertisements": "Advertenties",
      "copyright": "Auteursrecht",
      "export_control": "Exportcontrole",
      "franchises": "Franchises",
      "international_ip": "Internationaal IP",
      "ip_lawyer_other": "Anders",
      "ip_strategy": "IP-strategie",
      "ip_transactions": "IP-transacties",
      "licensing": "Licenties",
      "litigation_ip_lawyer": "Procesvoering",
      "non_disclosure_agreements_ip_lawyer": "Geheimhoudingsovereenkomsten",
      "patents": "Patenten",
      "technology_transfer": "Overdracht van technologie",
      "trade_secrets": "Handelsgeheimen",
      "trademarks": "Handelsmerken",
      "appliance_removal": "Verwijderen van apparatuur",
      "construction_waste_removal": "Verwijderen van bouwafval",
      "donation_pickup": "Donatie ophalen",
      "electronic_waste_removal": "Verwijdering van elektronisch afval",
      "furniture_removal": "Verwijderen van meubels",
      "general_junk_removal": "Verwijderen van afval",
      "hazardous_waste_removal": "Verwijdering van gevaarlijk afval",
      "house_garage_cleanout": "Schoonmaak van woning/garage",
      "junk_removal_other": "Anders",
      "yard_waste_removal": "Verwijderen van tuinafval",
      "employment_contracts_labor_lawyer": "Arbeidsovereenkomsten",
      "employment_law_labor_lawyer": "Arbeidsrecht",
      "exempt_employee_status": "Vrijgestelde werknemersstatus",
      "labor_law": "Arbeidsrecht",
      "labor_lawyer_other": "Anders",
      "labor_negotiations": "Arbeidsonderhandelingen",
      "privacy_rights": "Privacyrechten",
      "sexual_harassment": "Seksuele intimidatie",
      "unpaid_overtime": "Onbetaalde overuren",
      "whistle_blowing": "Klokkenluiden",
      "workers_compensation_labor_lawyer": "Werknemerscompensatie",
      "wrongful_termination": "Onrechtmatige beëindiging",
      "artificial_turf_installation": "Installatie van kunstgras",
      "concrete_masonry": "Betonmetselwerk",
      "driveway_landscaping": "Opritarchitectuur",
      "garden_decorations": "Tuindecoraties",
      "grading_resloping": "Gradering en herindeling",
      "hardscapes": "Hardscapes",
      "landscape_design": "Landschapsontwerp",
      "landscape_installations": "Landschapsinstallaties",
      "landscaper_other": "Anders",
      "outdoor_steps": "Buitentrappen",
      "outdoor_water_feature": "Waterpartijen buiten",
      "paving_driveway_walkway": "Oprit of looppad bestrating",
      "retaining_walls": "Keermuren",
      "sidewalk_walkway_landscaping": "Padlandschapsarchitectuur",
      "sod_seeding": "Graszoden en zaaien",
      "stone_masonry": "Stenen metselwerk",
      "arabic": "Arabic",
      "english": "English",
      "french": "French",
      "german": "German",
      "hebrew": "Hebreeuws",
      "italian": "Italian",
      "japanese": "Japanese",
      "korean": "Korean",
      "language_instructor_other": "Anders",
      "mandarin": "Mandarijn",
      "portuguese": "Portugees",
      "russian": "Russian",
      "sign_language": "Sign Language",
      "spanish": "Spanish",
      "irrigation_system_repair_maintenance": "Reparatie/onderhoud van irrigatiesysteem",
      "lawn_care_other": "Anders",
      "lawn_mowing_maintenance": "Gazon maaien/onderhoud",
      "lawn_pest_control": "Ongediertebestrijding gazon",
      "mulching": "Mulchen",
      "seeding": "Zaaien",
      "sod_installation": "Installatie van graszoden",
      "weed_control": "Onkruidbestrijding",
      "yard_cleanup": "Tuin opruimen",
      "appeals": "Beroepen",
      "case_assessment_litigation_lawyer": "Zaakevaluatie",
      "civil_litigation": "Civiele rechtszaken",
      "commercial_litigation": "Commerciële geschillen",
      "contracts_and_agreements": "Contracten en Overeenkomsten",
      "criminal_litigation": "Strafrechtelijke procesvoering",
      "litigation_lawyer_other": "Anders",
      "mediation_litigation_lawyer": "Mediation",
      "settlements": "Schikkingen",
      "building_lockout": "Buitensluiting gebouw",
      "copy_building_key": "Gebouwsleutels kopiëren",
      "copy_vehicle_key": "Voertuigsleutel kopiëren",
      "install_hardware": "Hardware installeren",
      "locksmith_other": "Anders",
      "new_key_fob": "Nieuwe sleutelhouder",
      "rekey_lock": "Slot opnieuw vergrendelen",
      "repair_hardware": "Hardware repareren",
      "vehicle_lockout": "Buitensluiting voertuig",
      "consent_issues": "Problemen met instemming",
      "diagnosis_errors": "Diagnosefouten",
      "malpractice_lawyer_other": "Anders",
      "medical_negligence": "Medische nalatigheid",
      "treatment_errors": "Behandelingsfouten",
      "massage_center_other": "Anders",
      "massage_school_advanced_neuromuscular_therapy": "Geavanceerde neuromusculaire therapie",
      "massage_school_business_and_ethics": "Bedrijfsleven en ethiek",
      "massage_school_clinical_therapies": "Klinische therapieën",
      "massage_school_continuing_education": "Voortgezet onderwijs",
      "massage_school_deep_tissue_massage": "Diepe weefselmassage",
      "massage_school_energetics": "Energetica",
      "massage_school_hydrotherapy": "Hydrotherapie",
      "massage_school_lymphatic_massage": "Lymfatische massage",
      "massage_school_online_massage_therapy": "Online Massagetherapie",
      "massage_school_other": "Anders",
      "massage_school_prenatal_massage": "Prenatale massage",
      "massage_school_sports_massage": "Sportmassage",
      "massage_school_student_massage_clinic": "Studentenmassagekliniek",
      "massage_school_swedish_massage": "Zweedse massage",
      "massage_theory": "Massagetheorie",
      "massage_therapy_training": "Cursussen massagetherapie",
      "in_state_move": "Verhuizing binnen de provincie",
      "local_move": "Lokale verhuizing",
      "mover_other": "Anders",
      "moving_junk_removal": "Afvalverwijdering",
      "moving_storage": "Opslag",
      "out_of_state_move": "Verhuizing buiten de provincie",
      "oversized_item_move": "Extra groot item verplaatsen",
      "packing_unpacking": "Inpakken/uitpakken",
      "senior_move": "Seniorenverhuizing",
      "vehicle_transport": "Voertuigtransport",
      "cardiac_care": "Cardiale zorg",
      "general_medical_care": "Algemene medische zorg",
      "hospice": "Hospice",
      "iv_therapy": "IV-therapie",
      "nursing_home_meal_services": "Maaltijdservices",
      "nursing_home_memory_care": "Geheugenzorg",
      "nursing_home_other": "Anders",
      "nursing_home_pain_management": "Pijnbeheer",
      "nursing_home_rehabilitation_services": "Revalidatiediensten",
      "nursing_home_wellness_programs": "Wellnessprogramma's",
      "outpatient_rehabilitation": "Ambulante revalidatie",
      "post_hospital_care": "Nazorg na ziekenhuisopname",
      "respiratory_and_pulmonary_care": "Ademhalings- en longzorg",
      "senior_activity_programs": "Activiteitenprogramma's voor senioren",
      "short_term_rehabilitation": "Revalidatie op korte termijn",
      "wound_care": "Wondverzorging",
      "exterior_painting": "Buitenschilderwerk",
      "interior_painting": "Binnenschilderwerk",
      "paint_cabinets": "Kasten schilderen",
      "paint_doors": "Deuren schilderen",
      "painter_other": "Anders",
      "repair_water_damage": "Waterschade herstellen",
      "staining": "Kleuring",
      "assault_battery": "Aanval en mishandeling",
      "auto_accidents": "Automatische ongelukken",
      "bicycle_accidents": "Fietsongevallen",
      "catastrophic_injuries": "Catastrofale verwondingen",
      "dog_bites": "Hondenbeten",
      "dui_injuries_personal_injury_lawyer": "Verwondingen door rijden onder invloed",
      "medical_malpractice": "Medische wanpraktijk",
      "motorcycle_accidents": "Ongevallen met motorfietsen",
      "pain_suffering": "Pijn en lijden",
      "pedestrian_accidents": "Voetgangersongevallen",
      "personal_injury_lawyer_other": "Anders",
      "product_liability": "Productaansprakelijkheid",
      "slip_fall": "Uitglijden & Vallen",
      "uninsured_motorist_claims": "Schadeclaims voor automobilistenverzekeringen",
      "workers_compensation_personal_injury_lawyer": "Werknemerscompensatie",
      "wrongful_death": "Onrechtmatige dood",
      "aerobics": "Aerobics",
      "athletic_performance": "Atletische prestaties",
      "circuit_training": "Circuittraining",
      "endurance": "Uithoudingsvermogen",
      "fitness_assessment": "Fitheidsevaluatie",
      "hiit": "HIIT",
      "nutritional_counseling": "Voedingsadvies",
      "personal_trainer_other": "Anders",
      "strength_conditioning": "Kracht en Conditie",
      "weight_loss": "Gewichtsverlies",
      "yoga": "Yoga",
      "ants": "Mieren",
      "bed_bugs": "Bedwantsen",
      "bees": "Bijen",
      "cockroaches": "Kakkerlakken",
      "fleas_or_mites": "Vlooien of mijten",
      "hornets_or_wasps": "Horzels of wespen",
      "mosquitoes": "Muggen",
      "pest_control_other": "Anders",
      "pest_inspection": "Inspectie",
      "rodents": "Knaagdieren",
      "spiders": "Spinnen",
      "termites": "Termieten",
      "wildlife": "Wildlife",
      "pet_adoption_birds": "Vogels",
      "pet_adoption_cats": "Katten",
      "pet_adoption_dogs": "Honden",
      "pet_adoption_farm_animals": "Boerderijdieren",
      "pet_adoption_fish": "Vis",
      "pet_adoption_other": "Anders",
      "pet_adoption_reptiles": "Reptielen",
      "pet_adoption_small_mammals": "Kleine zoogdieren",
      "pet_adoption_special_needs_animals": "Dieren met speciale behoeften",
      "cat_boarding": "Kattenpension",
      "cat_grooming": "Kattenverzorging",
      "cat_sitting_in_home": "Kattenoppas (in huis)",
      "dog_boarding": "Hondenopvang",
      "dog_boarding_with_training": "Hondenpension met cursussen",
      "dog_daycare": "Hondendagopvang",
      "dog_grooming": "Hondenverzorging",
      "dog_sitting_in_home": "Hondenoppas (in huis)",
      "dog_training": "Hondentraining",
      "dog_walking": "Hond uitlaten",
      "other_pet_boarding": "Andere huisdierenopvang",
      "other_pet_daycare": "Andere dagopvang voor huisdieren",
      "other_pet_grooming": "Andere verzorging van huisdieren",
      "other_pet_sitting_in_home": "Andere dierenoppas (in huis)",
      "pet_boarding_other": "Anders",
      "cat_bathing": "Kattenbaden",
      "cat_ear_cleaning": "Kattenoorreiniging",
      "cat_grooming_and_styling": "Kattenverzorging en -styling",
      "cat_nail_trimming": "Kattennagels knippen",
      "dog_anal_gland_expression": "Uitdrukking van de anale klier van de hond",
      "dog_bathing_and_blow_dry": "Honden baden en föhnen",
      "dog_ear_cleaning": "Hondenoorreiniging",
      "dog_flea_and_tick_treatment": "Behandeling tegen vlooien en teken bij honden",
      "dog_full_service_grooming": "Full-service hondenverzorging",
      "dog_grooming_and_styling": "Hondenverzorging en -styling",
      "dog_nail_trimming": "Nagels knippen van de hond",
      "dog_teeth_brushing": "Tandenreiniging van honden",
      "pet_grooming_other": "Anders",
      "aggressive_dog_training": "Training voor agressieve honden",
      "behavior_modification": "Gedragsverandering",
      "obedience_training": "Gehoorzaamheidstraining",
      "offleash_training": "Training zonder riem",
      "pet_trainer_other": "Anders",
      "puppy_training": "Puppytraining",
      "service_animal_training": "Training van hulpdieren",
      "sport_trick_training": "Sport- of tructraining",
      "training_other_animals": "Training voor andere dieren",
      "corporate_photo": "Zakelijk",
      "events_and_parties_photo": "Evenementen en feesten",
      "family_and_group_photo": "Gezin en groep",
      "headshots_and_portraits": "Portretfoto's en portretten",
      "individual_photo": "Persoonlijk",
      "maternity_and_newborn_photo": "Zwangerschap en pasgeborene",
      "photographer_other": "Anders",
      "product_photo": "Product",
      "real_estate_photo": "Onroerend goed",
      "school_portraits": "Schoolportretten",
      "wedding_and_engagement_photo": "Bruiloft en verloving",
      "find_leak": "Lek opsporen en repareren",
      "install_faucet": "Kraan installeren",
      "install_garbage_disposal": "Vuilnisafvoer installeren",
      "install_shower": "Douche installeren",
      "install_toilet": "Toilet installeren",
      "install_water_heater": "Waterverwarmer installeren",
      "plumbing_other": "Anders",
      "repair_faucet": "Kraan repareren",
      "repair_garbage_disposal": "Afvalverwerker repareren",
      "repair_outdoor_systems": "Buitensystemen repareren",
      "repair_pipe": "Pijp repareren",
      "repair_sewer": "Riolering repareren",
      "repair_shower": "Douche repareren",
      "repair_toilet": "Toilet repareren",
      "repair_water_heater": "Waterverwarmer repareren",
      "unclog_drain": "Afvoer ontstoppen",
      "commercial_pool_cleaning_maintenance": "Commerciële zwembadreiniging en onderhoud",
      "equipment_maintenance_repair": "Onderhoud en reparatie van apparatuur",
      "one_time_pool_cleaning": "Eenmalige zwembadreiniging",
      "ongoing_pool_cleaning": "Doorlopende zwembadreiniging",
      "pool_cleaner_other": "Anders",
      "pool_cleaner_water_features": "Waterpartijen",
      "seasonal_opening_closing": "Seizoensopening en -sluiting",
      "spa_hot_tub_cleaning": "Reiniging van spa's en bubbelbaden",
      "spa_hot_tub_repairs": "Reparaties aan spa's en bubbelbaden",
      "tile_pool_wall_cleaning": "Tegel- en zwembadwandreiniging",
      "water_testing_balancing": "Water testen en balanceren",
      "jetted_lap_pools": "Zwembaden met bubbelbad",
      "pool_construction": "Zwembadconstructie",
      "pool_contractor_commercial_projects": "Commerciële projecten",
      "pool_contractor_custom_designs": "Aangepaste ontwerpen",
      "pool_contractor_other": "Anders",
      "pool_contractor_renovation": "Renovatie",
      "pool_contractor_repair_cracks": "Scheuren repareren",
      "pool_contractor_repair_tile": "Tegel repareren",
      "pool_contractor_resurfacing": "Opnieuw aanleggen",
      "pool_contractor_water_features": "Waterpartijen",
      "pool_hot_tub_equipment": "Apparatuur voor zwembad en hottub",
      "spa_hot_tub_installation": "Installatie van spa's en hottubs",
      "bilingual_programs": "Tweetalige programma's",
      "early_preschool": "Vroege kleuterschool",
      "full_day_preschool": "Hele dag kleuterschool",
      "half_day_preschool": "Halve dag kleuterschool",
      "kindergarten_classes": "Kleuterklassen",
      "montessori_programs": "Montessori-programma's",
      "play_based_preschool": "Op spel gebaseerde kleuterschool",
      "preschool_infant_programs": "Babyprogramma's",
      "preschool_other": "Anders",
      "reggio_emilia_preschool": "Reggio Emilia-kleuterschool",
      "special_needs_programs": "Programma's voor speciale behoeften",
      "summer_camp": "Zomerkamp",
      "waldorf_preschool": "Waldorf-kleuterschool",
      "psychologist_other": "Anders",
      "buyer_agent": "Makelaar van de koper",
      "first_time_home_buyer": "Koper eerste woning",
      "foreclosed_properties": "In beslag genomen woningen",
      "luxury_properties": "Luxe woningen",
      "new_construction": "Nieuwbouw",
      "property_management": "Vastgoedbeheer",
      "real_estate_agent_other": "Anders",
      "relocation": "Verhuizing",
      "rentals": "Verhuur",
      "sellers_agent": "Makelaar van de verkoper",
      "commercial_real_estate": "Commercieel vastgoed",
      "easements": "Erfdienstbaarheden",
      "encroachment": "Inbreuk",
      "foreclosure_real_esate_lawyer": "Executieverkoop",
      "landlord_tenant_law": "Verhuurder- en huurdersrecht",
      "litigation_real_estate_lawyer": "Procesvoering",
      "mortgage_lending_law": "Hypotheek- en kredietrecht",
      "neighbor_hoa_disputes": "Geschillen tussen buren en VvE's",
      "property_damage": "Eigendomsschade",
      "purchase_agreements": "Koopovereenkomsten",
      "real_estate_contracts_transactions": "Vastgoedtransacties",
      "real_estate_lawyer_other": "Anders",
      "residential_real_estate": "Residentieel vastgoed",
      "title_services": "Titeldiensten",
      "trespassing": "Onrechtmatig betreden",
      "rehab_other": "Anders",
      "attic_venting": "Zolderventilatie",
      "gutter_installation": "Gootinstallatie",
      "gutter_repair": "Dakgootreparatie",
      "roof_inspection": "Dakinspectie",
      "roof_installation": "Dakinstallatie",
      "roof_repair": "Dakreparatie",
      "roofer_other": "Anders",
      "skylight_installation": "Dakraaminstallatie",
      "skylight_repair": "Dakraamreparatie",
      "storm_wind_damage_roof_repair": "Schadeherstel aan dak",
      "sewage_cleaning": "Schoonmaak",
      "sewage_excavation": "Uitgraving",
      "sewage_inspection": "Inspectie",
      "sewage_installation": "Installatie",
      "sewage_locating": "Lokaliseren",
      "sewage_maintenance_repairs": "Onderhoud en reparaties",
      "sewage_pro_other": "Anders",
      "sewage_pumping": "Pompen",
      "sewage_removal_demolition": "Verwijdering of Sloop",
      "remodeling_siding_pro": "Verbouwing",
      "repair_maintenance_siding_pro": "Reparatie en onderhoud",
      "siding_installation": "Installatie van gevelbeplating",
      "siding_pro_other": "Anders",
      "siding_removal": "Gevelbeplating verwijderen",
      "smart_home_other": "Anders",
      "commercial_snow_removal": "Commerciële sneeuwruiming",
      "residential_plowing": "Residentieel sneeuwruimen",
      "residential_shoveling_blowing": "Residentieel scheppen en blazen",
      "salt_sand_deicing": "Zout, zand en ontdooiing",
      "snow_relocation": "Sneeuwverplaatsing",
      "snow_removal_other": "Anders",
      "body_polish": "Lichaam polijsten",
      "body_wrap": "Lichaamspakking",
      "facial": "Gezicht",
      "hydrotherapy": "Hydrotherapie",
      "manicure": "Manicure",
      "massage": "Massage",
      "pedicure": "Pedicure",
      "peels": "Peels",
      "spa_other": "Anders",
      "spa_packages": "Spapakketten",
      "tanning": "Zonnebank",
      "waxing": "Waxen",
      "civil_tax_litigation": "Civiele belastingrechtszaken",
      "corporate_taxes": "Zakelijke belastingen",
      "criminal_tax_litigation": "Strafrechtelijke belastinggeschillen",
      "estate_tax_planning": "Planning voor vermogensbelasting",
      "failure_to_file": "Niet indienen",
      "innocent_spouse_relief": "Hulp voor onschuldige partner",
      "international_tax_services": "Internationale belastingdiensten",
      "irs_tax_problems": "Belastingproblemen IRS",
      "non_collectible_status": "Niet-inbare status",
      "offer_in_compromise": "Voorstel tot schikking",
      "tax_audits": "Belastingcontroles",
      "tax_lawyer_other": "Anders",
      "tax_liens_levies": "Belastingbeslagen en -heffingen",
      "tax_planning_lawyer": "Fiscale planning",
      "tax_relief": "Belastingverlichting",
      "accounting_support": "Boekhoudkundige ondersteuning",
      "business_incorporation_restructuring": "Oprichting & herstructurering",
      "cryptocurrency_taxes": "Cryptocurrency Belastingen",
      "irs_audit_representation": "Vertegenwoordiging bij IRS-belastingcontrole",
      "irs_filing": "IRS-aangifte",
      "irs_problem_consulting": "Advies bij IRS-belastingproblemen",
      "new_business_services": "Nieuwe zakelijke services",
      "payroll_support": "Ondersteuning bij salarisadministratie",
      "tax_planning_tax_specialist": "Fiscale planning",
      "tax_preparation": "Voorbereiding belastingaangifte",
      "tax_problem_consulting_tax_specialist": "Advies bij belastingproblemen",
      "tax_specialist_other": "Anders",
      "therapist_other": "Anders",
      "battery_service": "Batterijservice",
      "car_towing": "Auto wegslepen",
      "fuel_delivery": "Brandstoflevering",
      "local_hauling": "Lokaal transport",
      "long_distance_hauling": "Langeafstandsvervoer",
      "motorcycle_towing": "Wegslepen motorfiets",
      "special_vehicle_towing": "Wegslepen speciaal voertuig",
      "tire_change": "Banden verwisselen",
      "towing_other": "Anders",
      "case_assessment_traffic_lawyer": "Zaakevaluatie",
      "cdl_traffic_ticket": "CDL-verkeersboete",
      "dui_dwi_traffic_lawyer": "DUI",
      "fixit_ticket": "Reparatiebon",
      "parking_ticket": "Parkeerboete",
      "reckless_driving_traffic_lawyer": "Roekeloos rijden",
      "red_light_ticket": "Boete voor door rood licht rijden",
      "speeding_ticket": "Snelheidsboete",
      "suspended_license": "Opgeschorte licentie",
      "traffic_lawyer_other": "Anders",
      "traffic_ticket": "Verkeersboete",
      "cabling_and_bracing": "Bekabeling en versteviging",
      "stump_removal": "Verwijderen van boomstronken",
      "tree_planting": "Bomen planten",
      "tree_removal": "Boomverwijdering",
      "tree_service_other": "Anders",
      "tree_transplanting": "Boomverplanten",
      "tree_trimming_and_pruning": "Bomen trimmen en snoeien",
      "tutor_computer_science": "Informatica",
      "tutor_foreign_languages": "Vreemde talen",
      "tutor_geography": "Geografie",
      "tutor_government_and_economics": "Overheid en Economie",
      "tutor_history": "Geschiedenis",
      "tutor_homework_help": "Hulp bij huiswerk",
      "tutor_math": "Wiskunde",
      "tutor_other": "Anders",
      "tutor_reading_and_writing": "Lezen en schrijven",
      "tutor_science": "Wetenschap",
      "tutor_special_education": "Speciaal onderwijs",
      "tutor_test_pre_college_entrance": "Toetsvoorbereiding: Toegang tot College",
      "tutor_test_prep_grad_school_entrance": "Toetsvoorbereiding: Toegang tot Grad School",
      "tutor_test_prep_k8": "Toetsvoorbereiding: Lager en middelbaar onderwijs",
      "area_rug_cleaning": "Tapijtreiniging",
      "drapery_and_blind_cleaning": "Gordijn- en jaloeziereiniging",
      "leather_cleaning": "Leerreiniging",
      "mattress_cleaning": "Matrasreiniging",
      "upholstery_cleaner_other": "Anders",
      "upholstery_cleaning": "Meubelreiniging",
      "upholstery_water_damage_cleanup": "Waterschade opruimen",
      "bird_exotic_animal_care": "Verzorging van vogels en exotische dieren",
      "farm_barn_animal_care": "Boerderij- en schuurdierenverzorging",
      "microchipping": "Microchippen",
      "veterinarian_allergies": "Allergieën",
      "veterinarian_behavior_counseling": "Gedragstherapie",
      "veterinarian_dental_care": "Tandverzorging",
      "veterinarian_dermatology": "Dermatologie",
      "veterinarian_emergency_care": "Spoedeisende zorg",
      "veterinarian_end_of_life_care": "Zorg aan het einde van het leven",
      "veterinarian_examinations": "Examens",
      "veterinarian_nutrition_counseling": "Voedingsadvies",
      "veterinarian_other": "Anders",
      "veterinarian_preventive_care": "Preventieve zorg",
      "veterinarian_spay_neuter": "Steriliseren of castreren",
      "veterinarian_surgery": "Chirurgie",
      "veterinarian_vaccinations": "Vaccinaties",
      "aerial_videography": "Luchtvideografie",
      "documentary_video_production": "Documentaireproductie",
      "family_video_production": "Familievideoproductie",
      "live_streaming": "Live streamen",
      "photography": "Fotografie",
      "product_demonstrations": "Productdemonstratie",
      "promotional_video_production": "Promotionele videoproductie",
      "real_estate_video_production": "Videoproductie vastgoed",
      "special_event_video_production": "Videoproductie voor speciale evenementen",
      "video_editing": "Video bewerken",
      "videographer_other": "Anders",
      "voice_overs": "Voice-over",
      "wedding_video_production": "Videoproductie bruiloft",
      "fire_damage_cleanup_repair": "Brandschade opruimen/repareren",
      "water_damage_cleanup_repair": "Waterschade opruimen",
      "water_damage_flooring": "Vloeren",
      "water_damage_mold_inspection": "Schimmelinspectie",
      "water_damage_mold_removal": "Schimmelverwijdering",
      "water_damage_other": "Anders",
      "water_damage_painting": "Schilderen",
      "water_damage_pest_control": "Ongediertebestrijding",
      "water_damage_plumbing": "Sanitair",
      "water_damage_remodeling": "Renovatie",
      "water_damage_roofing": "Dakbedekking",
      "water_damage_sewage_cleanup": "Rioolreiniging",
      "adult_weight_loss_programs": "Programma's voor gewichtsverlies voor volwassenen",
      "diet_and_nutrition_counseling": "Dieet- en voedingsadvies",
      "kids_weight_loss_programs": "Programma's voor gewichtsverlies voor kinderen",
      "metabolic_testing": "Metabolische tests",
      "weight_loss_consultation_and_training": "Consultatie en training",
      "weight_loss_fitness_programs": "Fitnessprogramma's",
      "weight_loss_meal_planning": "Maaltijdplanning",
      "weight_loss_personal_training": "Persoonlijke training",
      "weight_loss_service_other": "Anders",
      "weight_loss_wellness_programs": "Wellnessprogramma's",
      "glass_and_mirror_cleaning": "Glas- en spiegelreiniging",
      "gutter_cleaning": "Dakgootreiniging",
      "power_pressure_washing": "Hogedrukreiniging",
      "rooftop_skylight_cleaning": "Dak/dakraam schoonmaken",
      "window_cleaner_other": "Anders",
      "window_cleaning": "Glasbewassing",
      "door_installation": "Deurinstallatie",
      "door_repair": "Deurreparatie",
      "glass_installation": "Glasinstallatie",
      "window_boardup": "Boardup",
      "window_installation": "Installatie van vensters",
      "window_repair": "Reparatie van vensters",
      "window_repair_other": "Anders",
      "install_new_wiper_blades": "Nieuwe ruitenwisserbladen installeren",
      "repair_power_window": "Elektrisch venster repareren",
      "repair_water_leak": "Waterlek repareren",
      "repair_windshield": "Voorruit repareren",
      "replace_rear_window": "Achterruit vervangen",
      "replace_side_view_mirrors": "Zijspiegels repareren",
      "replace_side_window": "Zijraam vervangen",
      "replace_sunroof": "Glas schuifdak vervangen",
      "replace_windshield": "Voorruit vervangen",
      "windshield_other": "Anders",
      "ashtanga": "Ashtanga",
      "hatha": "Hatha",
      "hot_yoga": "Hot yoga",
      "iyengar": "Iyengar",
      "kundalini": "Kundalini",
      "meditation": "Meditatie",
      "power_yoga": "Poweryoga",
      "restorative": "Herstellend",
      "vinyasa": "Vinyasa",
      "yin": "Yin",
      "yoga_instructor_other": "Anders"
    }
  }
}
